<template>
  <div id="payOnline">
    <el-row>
      <el-col :span="24" class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>电子支付设置</el-breadcrumb-item>
          <el-breadcrumb-item>{{ navigationMap[parkActiveName] }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true" class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID" filterable clearable placeholder="请选择客户">
            <el-option v-for="item in choiceCusts" :key="item.fCustID" :label="item.unionName" :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场库名称::">
          <el-input placeholder="请输入场库名称" v-model="bindQueryInput" class="input-with-select">
            <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item label="场库编号::">
          <el-input placeholder="请输入场库编号" v-model="bindQueryfParkNo" class="input-with-select">
            <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item label="电子支付::">
          <el-select v-model="selPayType" multiple filterable :clearable="true" placeholder="选择支付/发票类型" class="payTypeSel"
            style="width:300px">
            <el-option v-for="item in payTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="bindQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" size="small" icon="el-icon-share" :loading="export_loading" v-if="is_export"
            @click="exportData">{{ export_msg }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24" style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="parkActiveName" type="card" @tab-click="tabClick">
        <el-tab-pane label="场库列表" name="parkList">
          <el-row>
            <el-table :data="parkList" border highlight-current-row v-loading="loading" style="width: 100%"
              :height="tableHeight" ref="singleTable">
              <el-table-column type="index" width="50" label="序号" :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName" width="180" label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo" width="80" label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName" width="160" label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkNo" width="80" label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName" width="160" label="场库名称">
              </el-table-column>
              <el-table-column prop="fParkTypeName" width="120" label="场库类型">
              </el-table-column>
              <!-- <el-table-column prop="fInvoiceType"
                               width="100"
                               label="电子发票">
              </el-table-column> -->
              <el-table-column prop="fPayOnlineType" label="电子支付">
              </el-table-column>
              <el-table-column fixed="right" align="center" label="操作" width="160">
                <template slot-scope="scope">
                  <el-button @click="viewPark(scope.row)" type="success" size="mini">查看</el-button>
                  <el-button size="mini" type="warning" v-if="is_edit"
                    @click="editParkClient(scope.$index, scope.row)">编辑</el-button>
                  <!-- <el-button size="mini"
                             type="info"
                             v-if="is_syn"
                             @click="synPark(scope.$index, scope.row,false)">上传</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步" name="synParkList">
          <el-row>
            <el-table :data="synParkList" border :row-class-name="tableRowClassName" highlight-current-row
              v-loading="loading" style="width: 100%" :height="tableHeight" ref="singleTable">
              <el-table-column type="index" width="50" label="序号" :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo" width="80" label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName" width="200" label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkNo" width="80" label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName" width="200" label="场库名称">
              </el-table-column>
              <el-table-column prop="fParkTypeName" width="100" label="场库类型">
              </el-table-column>
              <!-- <el-table-column prop="fInvoiceType"
                               width="100"
                               label="电子发票">
              </el-table-column> -->
              <el-table-column prop="fPayOnlineType" label="电子支付">
              </el-table-column>
              <el-table-column prop="fSyncRemark" label="同步说明">
              </el-table-column>
              <el-table-column fixed="right" align="center" label="操作" width="300">
                <template slot-scope="scope">
                  <el-button @click="viewPark(scope.row)" type="success" size="mini">查看</el-button>
                  <el-button size="mini" type="warning" v-if="is_edit"
                    @click="editParkClient(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" v-if="is_del"
                    @click="deleteParkClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini" type="info" v-if="is_syn"
                    @click="synPark(scope.$index, scope.row, true)">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background @size-change="handleSizeChange" :current-page.sync="pageIndex"
            @current-change="handlePage" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes, prev, pager, next, jumper" :total="total" v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="parkPayEditOrDetail">
      <el-dialog :title="detailTitle" :visible.sync="parkEditOrDetailVisible" v-dialogDrag top="7vh" left="0vh"
        width="60%">
        <el-form :inline="true" label-width="100px">
          <el-tabs v-model="editOrDetail" tab-position="left" type="card" @tab-click="tab_click">
            <el-tab-pane name="editBaseInfo">
              <span slot="label"><i class="el-icon-check" v-if="(RJInvoiceObject.p99160 == '1')"></i> 容津发票</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  容津电子发票
                </legend>
                <el-form :model="RJInvoiceObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="RJInvoiceObject.IsDefault" @change="setParams($event, 1)"
                          :disabled="!isEdit">
                          <el-radio :label="true">商秸参数</el-radio>
                          <el-radio :label="false">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="RJInvoiceObject.p99110" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="KEY::">
                        <el-input v-model="RJInvoiceObject.p99120" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票点参数::">
                        <el-input v-model="RJInvoiceObject.p99130" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="上传数据地址::">
                        <el-input v-model="RJInvoiceObject.p99140" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票链接::">
                        <el-input v-model="RJInvoiceObject.p99150" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="RJInvoiceObject.p99160" @change="changeInvoiceEnable($event, 1)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票天数::">
                        <el-input v-model="RJInvoiceObject.p99151" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="公司代码::">
                        <el-input v-model="RJInvoiceObject.p99152" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="版本号::">
                        <el-radio-group v-model="RJInvoiceObject.p99153" @change="setParams($event, 18)"
                          :disabled="!isEdit">
                          <el-radio label="0">普通发票</el-radio>
                          <el-radio label="1">全电发票</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="BSTADInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(BSTInfoObject.p78558 == '1' || BSTTwoInfoObject.p78578 == '1')"></i>泊斯特广告</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="BSTADReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="BSTADReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="BSTADReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="BSTADReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="BSTADReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="BSTADReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>泊斯特广告参数</legend>
                <el-form :model="BSTInfoObject" :inline="true" label-width="140px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="流量主账号::">
                        <el-input v-model="BSTInfoObject.p78551" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="帐户密钥::">
                        <el-input v-model="BSTInfoObject.p78552" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场编号::">
                        <el-input v-model="BSTInfoObject.p78553" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="停车场类型::">
                        <el-select v-model="BSTInfoObject.p78554" placeholder="请选择" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in parkTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="停车场地址::">
                        <el-input v-model="BSTInfoObject.p78555" style="width:500px" :disabled="!isEdit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="API请求URL::">
                        <el-input v-model="BSTInfoObject.p78557" class="myParkInput" :disabled="!isEdit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="BSTInfoObject.p78558" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item label="初始化结果::" class="fRemark_bigrow ">
                        <el-input type="textarea" v-model="BSTInfoObject.p78556" :disabled="true"
                          class="parkBigTextArea"></el-input>
                      </el-form-item>
                      <el-form-item label=" " class="fRemark_row ">
                        <el-button type="primary" :loading="init_loading" @click="initAd">初始化</el-button>
                        <el-button type="success" class="BSTInfoResult_btn" :data-clipboard-text='BSTInfoObject.p78556'
                          @click="copy($event, 'BSTInfoResult_btn')">复制初始化结果</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>泊斯特广告2.0参数</legend>
                <el-form :model="BSTTwoInfoObject" :inline="true" label-width="140px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="流量主账号::">
                        <el-input v-model="BSTTwoInfoObject.p78571" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="帐户密钥::">
                        <el-input v-model="BSTTwoInfoObject.p78572" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场编号::">
                        <el-input v-model="BSTTwoInfoObject.p78573" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="停车场类型::">
                        <el-select v-model="BSTTwoInfoObject.p78574" placeholder="请选择" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in parkTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场地址::">
                        <el-input v-model="BSTTwoInfoObject.p78575" :disabled="!isEdit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="AccessKeyld(中移)::">
                        <el-input v-model="BSTTwoInfoObject.p78579" :disabled="!isEdit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="API请求URL::">
                        <el-input v-model="BSTTwoInfoObject.p78577" class="myParkInput" :disabled="!isEdit">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="BSTTwoInfoObject.p78578" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <el-form-item label="初始化结果::" class="fRemark_bigrow ">
                        <el-input type="textarea" v-model="BSTTwoInfoObject.p78576" :disabled="true"
                          class="parkBigTextArea"></el-input>
                      </el-form-item>
                      <el-form-item label=" " class="fRemark_row ">
                        <el-button type="primary" :loading="inittwo_loading" @click="initTwoAd">初始化</el-button>
                        <el-button type="success" class="BSTTwoInfoResult_btn"
                          :data-clipboard-text='BSTTwoInfoObject.p78576'
                          @click="copy($event, 'BSTTwoInfoResult_btn')">复制初始化结果</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="EInvoiceObject">
              <span slot="label"><i class="el-icon-check" v-if="(EInvoiceObject.p99299 == '1')"></i> E开票</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  E开票
                </legend>
                <el-form :model="EInvoiceObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票方公司名称::">
                        <el-input v-model="EInvoiceObject.p99210" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票方税号::">
                        <el-input v-model="EInvoiceObject.p99220" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票方机号::">
                        <el-input v-model="EInvoiceObject.p99230" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="公司电话::">
                        <el-input v-model="EInvoiceObject.p99250" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="公司地址::">
                        <el-input v-model="EInvoiceObject.p99240" :disabled="!isEdit" style="width:500px"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票联系人::">
                        <el-input v-model="EInvoiceObject.p99260" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="发票回传路径::">
                        <el-input v-model="EInvoiceObject.p99270" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="撤销开票命令::">
                        <el-input v-model="EInvoiceObject.p99280" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="商品税收编码::">
                        <el-input v-model="EInvoiceObject.p99290" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="EInvoiceObject.p99299" @change="changeInvoiceEnable($event, 2)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票天数::">
                        <el-input v-model="EInvoiceObject.p99291" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="unionEInvoiceObject">
              <span slot="label"><i class="el-icon-check" v-if="(unionEInvoiceObject.p99507 == '1')"></i> 银联发票</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  银联电子发票
                </legend>
                <el-form :model="unionEInvoiceObject" :inline="true" label-width="120px">
                  <!--<el-row>-->
                  <!--<el-col :span="24">-->
                  <!--<el-form-item label="参数::">-->
                  <!--<el-radio-group v-model="unionEInvoiceObject.IsDefault"-->
                  <!--@change="setParams($event,0)"-->
                  <!--:disabled="!isEdit">-->
                  <!--<el-radio :label="true">商秸参数</el-radio>-->
                  <!--<el-radio :label="false">无参数</el-radio>-->
                  <!--</el-radio-group>-->
                  <!--</el-form-item>-->
                  <!--</el-col>-->
                  <!--</el-row>-->
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="unionEInvoiceObject.p99501" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="KEY::">
                        <el-input v-model="unionEInvoiceObject.p99503" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="终端号::">
                        <el-input v-model="unionEInvoiceObject.p99502" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消息来源::">
                        <el-input v-model="unionEInvoiceObject.p99504" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="发票地址::">
                        <el-input v-model="unionEInvoiceObject.p99505" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="unionEInvoiceObject.p99507" @change="changeInvoiceEnable($event, 0)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票链接::">
                        <el-input v-model="unionEInvoiceObject.p99506" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票天数::">
                        <el-input v-model="unionEInvoiceObject.p99508" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商品税率(%)::">
                        <el-input v-model="unionEInvoiceObject.p99509" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="版本号::">
                        <el-radio-group v-model="unionEInvoiceObject.p99510" :disabled="!isEdit">
                          <el-radio label="0">普通发票</el-radio>
                          <el-radio label="1">全电发票</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="(unionEInvoiceObject.p99510 == '1')">
                    <el-col :span="12">
                      <el-form-item label="商品名称::">
                        <el-input v-model="unionEInvoiceObject.p99518" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="商品编码::">
                        <el-input v-model="unionEInvoiceObject.p99519" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="(unionEInvoiceObject.p99510 == '1')">
                    <legend style="padding-top: 10px">全电发票配置（不动产租赁服务发票）</legend>
                  </el-row>
                  <el-row v-if="(unionEInvoiceObject.p99510 == '1')">
                    <el-col :span="12">
                      <el-form-item label="产权证编号::">
                        <el-input v-model="unionEInvoiceObject.p99511" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="面积::">
                        <el-input v-model="unionEInvoiceObject.p99512" :disabled="!isEdit" class="myParkInput"
                          placeholder="请输入占地面积（单位㎡）"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--<el-row v-if="(unionEInvoiceObject.p99510 == '1')">
                    <el-col :span="12">
                      <el-form-item label="租赁起始日期::">
                        <el-date-picker v-model="unionEInvoiceObject.p99513" type="date" :disabled="!isEdit"
                          placeholder="选择起始日期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="租赁结束日期::">
                        <el-date-picker v-model="unionEInvoiceObject.p99514" type="date" :disabled="!isEdit"
                          placeholder="选择结束日期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>-->
                  <el-row v-if="(unionEInvoiceObject.p99510 == '1')">
                    <el-col :span="12">
                      <el-form-item label="跨地（市）标志::">
                        <el-radio-group v-model="unionEInvoiceObject.p99515">
                          <el-radio label="N">否</el-radio>
                          <el-radio label="Y">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地址::">
                        <el-input v-model="unionEInvoiceObject.p99516" :disabled="!isEdit" class="myParkInput"
                          placeholder="xxx省&xxx市&xxx区/县"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="(unionEInvoiceObject.p99510 == '1')">
                    <el-col :span="12">
                      <el-form-item label="详细地址::">
                        <el-input v-model="unionEInvoiceObject.p99517" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="gdEInvoiceObject">
              <span slot="label"><i class="el-icon-check" v-if="(gdEInvoiceObject.p99607 == '1')"></i>云票儿</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  云票儿
                </legend>
                <el-form :model="gdEInvoiceObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="gdEInvoiceObject.IsDefault" @change="setParams($event, 4)"
                          :disabled="!isEdit">
                          <el-radio :label="true">商秸参数</el-radio>
                          <el-radio :label="false">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPKey::">
                        <el-input v-model="gdEInvoiceObject.p99602" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="AppSecret::">
                        <el-input v-model="gdEInvoiceObject.p99603" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="版本号::">
                        <el-input v-model="gdEInvoiceObject.p99601" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票API链接::">
                        <el-input v-model="gdEInvoiceObject.p99604" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="纳税人识别码::">
                        <el-input v-model="gdEInvoiceObject.p99606" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票链接::">
                        <el-input v-model="gdEInvoiceObject.p99610" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                      <el-form-item label="门店编码::">
                        <el-input v-model="gdEInvoiceObject.p99605"
                                  :disabled="!isEdit"
                                  class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col> -->
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商品税率(%)::">
                        <el-input v-model="gdEInvoiceObject.p99608" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="税收商品编码::">
                        <el-input v-model="gdEInvoiceObject.p99609" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="gdEInvoiceObject.p99607" @change="changeInvoiceEnable($event, 3)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票天数::">
                        <el-input v-model="gdEInvoiceObject.p99611" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="HXInvoiceObject">
              <span slot="label"><i class="el-icon-check" v-if="(HXInvoiceObject.p99701 == '1')"></i>航信发票</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  航信发票
                </legend>
                <el-form :model="HXInvoiceObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="HXInvoiceObject.p99712" @change="setHXDefault($event)"
                          :disabled="!isEdit">
                          <el-radio label="1">天津天河城参数</el-radio>
                          <el-radio label="0">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="纳税人识别号::">
                        <el-input v-model="HXInvoiceObject.p99702" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票方名称::">
                        <el-input v-model="HXInvoiceObject.p99714" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="销货方名称::">
                        <el-input v-model="HXInvoiceObject.p99703" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="销货方地址::">
                        <el-input v-model="HXInvoiceObject.p99704" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="销货方电话::">
                        <el-input v-model="HXInvoiceObject.p99705" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="销货方银行帐号::">
                        <el-input v-model="HXInvoiceObject.p99706" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商品分类编码::">
                        <el-input v-model="HXInvoiceObject.p99707" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票员::">
                        <el-input v-model="HXInvoiceObject.p99708" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="收款员::">
                        <el-input v-model="HXInvoiceObject.p99709" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="复核员::">
                        <el-input v-model="HXInvoiceObject.p99710" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="税率::">
                        <el-input v-model="HXInvoiceObject.p99711" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票天数::">
                        <el-input v-model="HXInvoiceObject.p99713" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="HXInvoiceObject.p99701" @change="changeInvoiceEnable($event, 4)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="HTInvoiceObject">
              <span slot="label"><i class="el-icon-check"
                  v-if="(HTInvoiceObject.p99808 == '1' || TJHTInvObject.p99861 == '1' || BJHTInvObject.p99908 == '1')"></i>航天发票</span>
              <el-tabs type="card" class="child_card">
                <el-tab-pane label="诺诺电子发票企业端同步发票通用版(2.2.7)">
                  <fieldset>
                    <el-form :model="HTInvoiceObject" :inline="true" label-width="120px">
                      <el-row v-if="(HTInvoiceObject.p99810 !== '1')">
                        <el-col :span="24">
                          <el-form-item label="身份认证::">
                            <el-input v-model="HTInvoiceObject.p99801" :disabled="!isEdit" style="width:500px"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="(HTInvoiceObject.p99810 == '1')">
                        <el-col :span="12">
                          <el-form-item label="AppKey::">
                            <el-input v-model="HTInvoiceObject.p99815" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="AppSecret::">
                            <el-input v-model="HTInvoiceObject.p99816" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="(HTInvoiceObject.p99810 == '1')">
                        <el-col :span="12">
                          <el-form-item label="Token::">
                            <el-input v-model="HTInvoiceObject.p99817" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="商品名称::">
                            <el-input v-model="HTInvoiceObject.p99809" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="开票员::">
                            <el-input v-model="HTInvoiceObject.p99803" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="销方税号::">
                            <el-input v-model="HTInvoiceObject.p99804" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="税收分类编码::">
                            <el-input v-model="HTInvoiceObject.p99806" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="(HTInvoiceObject.p99810 == '1')">
                        <el-col :span="12">
                          <el-form-item label="销方电话::">
                            <el-input v-model="HTInvoiceObject.p99818" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="销方地址::">
                            <el-input v-model="HTInvoiceObject.p99819" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="税率(%)::">
                            <el-input v-model="HTInvoiceObject.p99805" :disabled="!isEdit" class="myParkInput"></el-input>
                            <span style="color:red">*注意：不需要%</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="开票天数::">
                            <el-input v-model="HTInvoiceObject.p99807" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="开票请求链接::">
                            <el-input v-model="HTInvoiceObject.p99802" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="启用状态::">
                            <el-radio-group v-model="HTInvoiceObject.p99808" @change="changeInvoiceEnable($event, 5)"
                              :disabled="!isEdit">
                              <el-radio label="0">禁用</el-radio>
                              <el-radio label="1">启用</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="版本号::">
                            <el-radio-group v-model="HTInvoiceObject.p99810" @change="setParams($event, 19)"
                              :disabled="!isEdit">
                              <el-radio label="0">普通发票</el-radio>
                              <el-radio label="1">全电发票</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="false">
                        <legend style="padding-top: 10px">全电发票配置（不动产租赁服务发票）</legend>
                      </el-row>
                      <el-row v-if="false">
                        <el-col :span="12">
                          <el-form-item label="产权证编号::">
                            <el-input v-model="HTInvoiceObject.p99811" :disabled="!isEdit" class="myParkInput"
                              placeholder="选填项"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="跨地（市）标志::">
                            <el-radio-group v-model="HTInvoiceObject.p99812">
                              <el-radio label="0">否</el-radio>
                              <el-radio label="1">是</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="false">
                        <el-col :span="12">
                          <el-form-item label="地址::">
                            <el-input v-model="HTInvoiceObject.p99813" :disabled="!isEdit" class="myParkInput"
                              placeholder="xxx省xxx市xxx区/县"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="详细地址::">
                            <el-input v-model="HTInvoiceObject.p99814" :disabled="!isEdit" class="myParkInput"
                              placeholder="须包含街、路、村、乡、镇、道"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </fieldset>
                </el-tab-pane>
                <el-tab-pane label="诺诺电子发票-自用型">
                  <fieldset>
                    <el-form :model="TJHTInvObject" :inline="true" label-width="120px">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AppKey::">
                            <el-input v-model="TJHTInvObject.p99851" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="AppSecret::">
                            <el-input v-model="TJHTInvObject.p99852" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="商品名称::">
                            <el-input v-model="TJHTInvObject.p99857" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="开票员::">
                            <el-input v-model="TJHTInvObject.p99856" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="销方税号::">
                            <el-input v-model="TJHTInvObject.p99853" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="销方电话::">
                            <el-input v-model="TJHTInvObject.p99854" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <el-form-item label="销方地址::">
                            <el-input v-model="TJHTInvObject.p99855" :disabled="!isEdit" style="width:500px;"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="税率(%)::">
                            <el-input v-model="TJHTInvObject.p99858" :disabled="!isEdit" class="myParkInput"></el-input>
                            <span style="color:red">*注意：不需要%</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="开票天数::">
                            <el-input v-model="TJHTInvObject.p99860" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="开票请求链接::">
                            <el-input v-model="TJHTInvObject.p99859" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="启用状态::">
                            <el-radio-group v-model="TJHTInvObject.p99861" @change="changeInvoiceEnable($event, 6)"
                              :disabled="!isEdit">
                              <el-radio label="0">禁用</el-radio>
                              <el-radio label="1">启用</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </fieldset>
                </el-tab-pane>
                <el-tab-pane label="北京航天电子发票">
                  <fieldset>
                    <el-form :model="BJHTInvObject" :inline="true" label-width="120px">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="销方税号::">
                            <el-input v-model="BJHTInvObject.p99901" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="开票员::">
                            <el-input v-model="BJHTInvObject.p99902" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="收款员::">
                            <el-input v-model="BJHTInvObject.p99914" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="复核人::">
                            <el-input v-model="BJHTInvObject.p99915" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="商品名称::">
                            <el-input v-model="BJHTInvObject.p99903" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="税收分类编码::">
                            <el-input v-model="BJHTInvObject.p99904" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="税率(%)::">
                            <el-input v-model="BJHTInvObject.p99905" :disabled="!isEdit" class="myParkInput"
                              placeholder="税率以小数形式给出，例：0.05"></el-input>
                            <span style="color:red">*注意：这里填写小数</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="开票天数::">
                            <el-input v-model="BJHTInvObject.p99906" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="开票请求链接::">
                            <el-input v-model="BJHTInvObject.p99907" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="启用状态::">
                            <el-radio-group v-model="BJHTInvObject.p99908" @change="changeInvoiceEnable($event, 7)"
                              :disabled="!isEdit">
                              <el-radio label="0">禁用</el-radio>
                              <el-radio label="1">启用</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <!--<el-row>
                        <el-col :span="12">
                          <el-form-item label="不动产地址::">
                            <el-input v-model="BJHTInvObject.p99909" :disabled="!isEdit" class="myParkInput" placeholder="xxx省xxx市xxx区/县"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="不动产详细地址::">
                            <el-input v-model="BJHTInvObject.p99910" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="跨地（市）标志::">
                            <el-radio-group v-model="BJHTInvObject.p99911">
                              <el-radio label="N">否</el-radio>
                              <el-radio label="Y">是</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="产权证书编号::">
                            <el-input v-model="BJHTInvObject.p99912" :disabled="!isEdit" class="myParkInput"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="单位面积::">
                            <el-input v-model="BJHTInvObject.p99913" :disabled="!isEdit" class="myParkInput" placeholder="请输入占地面积（单位㎡）"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>-->
                    </el-form>
                  </fieldset>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane name="unionPayInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(unionPayInfoObject.p71060 == '1' || unionPayInfoObject.p71190 == '1' || unionPayInfoObject.p71350 == '1')"></i>
                银联商务</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="unionPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="unionPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="unionPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="unionPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="unionPayReg.fEndDate" :disabled="!isEdit" type="date"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="unionPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>银联商务BtoC设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="POS通商户号::">
                        <el-input v-model="unionPayInfoObject.p71010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="POS终端号::">
                        <el-input v-model="unionPayInfoObject.p71020" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="unionPayInfoObject.p71030" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPKEY::">
                        <el-input v-model="unionPayInfoObject.p71040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="unionPayInfoObject.p71050" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="unionPayInfoObject.p71060" :disabled="!isEdit"
                          @change="changeEnable($event, 1, 'b2c')">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>银联商务CtoB设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="unionPayInfoObject.p71110" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端编号::">
                        <el-input v-model="unionPayInfoObject.p71120" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="业务类型::">
                        <el-input v-model="unionPayInfoObject.p71130" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消息来源::">
                        <el-input v-model="unionPayInfoObject.p71140" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="消息来源ID::">
                        <el-input v-model="unionPayInfoObject.p71150" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Key::">
                        <el-input v-model="unionPayInfoObject.p71160" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="unionPayInfoObject.p71210" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="unionPayInfoObject.p71190" :disabled="!isEdit"
                          @change="changeEnable($event, 1, 'c2b')">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票状态::">
                        <el-radio-group v-model="unionPayInfoObject.p71221" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>银联无感支付</legend>
                <el-form :inline="true" label-width="130px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="场库ID::">
                        <el-input v-model="unionPayInfoObject.p71310" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="厂商标识::">
                        <el-input v-model="unionPayInfoObject.p71320" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="扣款商户号::">
                        <el-input v-model="unionPayInfoObject.p71330" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="参数加密KEY::">
                        <el-input v-model="unionPayInfoObject.p71340" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="无感支付链接::">
                        <el-input v-model="unionPayInfoObject.p71341" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="unionPayInfoObject.p71350" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="回调通知地址::" class="btn_copy_content">
                        <el-input :disabled="true" style="width:500px" :value="UnionPayCallbackUrl"></el-input>
                        <el-button type="warning" size="mini" class="UnionPayCallbackUrl_btn"
                          :data-clipboard-text='UnionPayCallbackUrl'
                          @click="copy($event, 'UnionPayCallbackUrl_btn')">复制</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="停车费查询地址::" class="btn_copy_content">
                        <el-input :disabled="true" style="width:500px" :value="UnionPayQueryPreAmountUrl"></el-input>
                        <el-button type="warning" size="mini" class="UnionPayQueryPreAmountUrl_btn"
                          :data-clipboard-text='UnionPayQueryPreAmountUrl'
                          @click="copy($event, 'UnionPayQueryPreAmountUrl_btn')">复制</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="场库信息查询地址::" class="btn_copy_content">
                        <el-input :disabled="true" style="width:500px" :value="UnionPayQueryParkInfoUrl"></el-input>
                        <el-button type="warning" size="mini" class="UnionPayQueryParkInfoUrl_btn"
                          :data-clipboard-text='UnionPayQueryParkInfoUrl'
                          @click="copy($event, 'UnionPayQueryParkInfoUrl_btn')">复制</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>银联ERP积分抵扣设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="SignKey::">
                        <el-input v-model="unionPayInfoObject.p71991" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="AppKey::">
                        <el-input v-model="unionPayInfoObject.p71992" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="积分抵扣链接::">
                        <el-input v-model="unionPayInfoObject.p71990" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="MethodVer::">
                        <el-input v-model="unionPayInfoObject.p71993" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="加签算法::">
                        <el-select v-model="unionPayInfoObject.p71994" :disabled="!isEdit" placeholder="请选择"
                          style="width:220px;">
                          <el-option label="MD5" value="0">
                          </el-option>
                          <el-option label="SHA256" value="1">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>

            <el-tab-pane name="dcepInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(unionPayInfoObject.p71409 == '1' || unionPayInfoObject.p71426 == '1')"></i> 银联数字货币</span>
              <fieldset>
                <legend style="padding-top: 10px">银联数字货币BtoC设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="unionPayInfoObject.p71423" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPKEY::">
                        <el-input v-model="unionPayInfoObject.p71424" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="unionPayInfoObject.p71421" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端号::">
                        <el-input v-model="unionPayInfoObject.p71422" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="unionPayInfoObject.p71425" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="unionPayInfoObject.p71426" :disabled="!isEdit"
                          @change="changeEnable($event, 1, 'dcepB2C')">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </el-form>
              </fieldset>
              <!-- <fieldset>
                <legend>银联数字货币CtoB设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="数字货币APPID::">
                        <el-input v-model="unionPayInfoObject.p71401" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="数字货币APPKEY::">
                        <el-input v-model="unionPayInfoObject.p71402" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="unionPayInfoObject.p71403" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端号::">
                        <el-input v-model="unionPayInfoObject.p71404" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="机构终端号::">
                        <el-input v-model="unionPayInfoObject.p71405" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="密钥Key::">
                        <el-input v-model="unionPayInfoObject.p71406" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="来源编号::">
                        <el-input v-model="unionPayInfoObject.p71408" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="unionPayInfoObject.p71407" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="unionPayInfoObject.p71409" :disabled="!isEdit"
                          @change="changeEnable($event, 1, 'dcep')">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset> -->
            </el-tab-pane>
            <el-tab-pane name="wechatSerInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="wechatSerInfoObject.p72070 == '1' || wechatSerInfoObject.p72120 == '1' || wechatSerInfoObject.p72170 == '1' || wechatSerInfoObject.p72182 == '1' || wechatSerInfoObject.p72190 == '1'"></i>
                微信商户号</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="weChatSvrPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="weChatSvrPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="weChatSvrPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="weChatSvrPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="weChatSvrPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="weChatSvrPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>服务商户</legend>
                <el-form :model="wechatSerInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="wechatSerInfoObject.IsDefault" @change="setParams($event, 2)"
                          :disabled="!isEdit">
                          <el-radio :label="0">商秸参数</el-radio>
                          <el-radio :label="1">HT参数</el-radio>
                          <el-radio :label="-1">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="名称::">
                        <el-input v-model="wechatSerInfoObject.p72122" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="服务商公众号APPID::" label-width="140px">
                        <el-input v-model="wechatSerInfoObject.p72010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="服务商户号::">
                        <el-input v-model="wechatSerInfoObject.p72020" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="子商户公众号ID::" label-width="140px">
                        <el-input v-model="wechatSerInfoObject.p72030" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="子商户号::">
                        <el-input v-model="wechatSerInfoObject.p72040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="服务商Key::" label-width="140px">
                        <el-input v-model="wechatSerInfoObject.p72050" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="公众号密钥::">
                        <el-input v-model="wechatSerInfoObject.p72060" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="进场通知模板::" label-width="140px">
                        <el-input v-model="wechatSerInfoObject.p72100" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="出场通知模板::">
                        <el-input v-model="wechatSerInfoObject.p72110" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="支付链接::" label-width="140px">
                        <el-input v-model="wechatSerInfoObject.p72080" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="wechatSerInfoObject.p72070" :disabled="!isEdit"
                          @change="changeEnable($event, 2)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="无感支付::" label-width="140px">
                        <el-radio-group v-model="wechatSerInfoObject.p72120" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" v-if="false">
                      <el-form-item label="参数定制::">
                        <el-radio-group v-model="wechatSerInfoObject.p72121" :disabled="!isEdit">
                          <el-radio label="0">否</el-radio>
                          <el-radio label="1">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row style="padding-left:80px;">
                    <div>
                      <label>点金计划【支付成功结果页】:</label>
                      <div><label>扫码开闸：</label><el-link type="primary" :underline="false">{{
                        (this.pay_url.replace(/(\/*$)/g, "") + '/QR') }}</el-link></div>
                      <div><label>申请开票：</label><el-link type="primary" :underline="false">{{
                        (this.pay_url.replace(/(\/*$)/g, "") + '/PayResult') }}</el-link></div>
                    </div>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>微信找零</legend>
                <el-form :model="wechatSerInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户名称::">
                        <el-input v-model="wechatSerInfoObject.p72130" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="红包祝福语::">
                        <el-input v-model="wechatSerInfoObject.p72140" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="活动名称::">
                        <el-input v-model="wechatSerInfoObject.p72150" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="wechatSerInfoObject.p72170" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="wechatSerInfoObject.p72160" :disabled="!isEdit" style="width:500px"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>微信无感4.0</legend>
                <el-form :model="wechatSerInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="证书序列号::">
                        <el-input v-model="wechatSerInfoObject.p72180" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="wechatSerInfoObject.p72182" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="商户私钥::">
                        <el-input type="textarea" v-model="wechatSerInfoObject.p72181" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>享泊公众号消息推送</legend>
                <el-form :model="wechatSerInfoObject" :inline="true" label-width="120px">
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="wechatSerInfoObject.p72183" :disabled="!isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>微信服务商小程序</legend>
                <el-form :model="wechatSerInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="小程序APPID::">
                        <el-input v-model="wechatSerInfoObject.p72191" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="小程序密钥::">
                        <el-input v-model="wechatSerInfoObject.p72192" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="wechatSerInfoObject.p72190" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="wechatComInfo">
              <span slot="label"><i class="el-icon-check" v-if="wechatComInfoObject.p73050 == '1'"></i> 微信公众号</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="weChatComPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="weChatComPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="weChatComPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="weChatComPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="weChatComPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="weChatComPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>普通商户</legend>
                <el-form :model="wechatComInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="公众账号ID::">
                        <el-input v-model="wechatComInfoObject.p73010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="wechatComInfoObject.p73020" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="AppKey::">
                        <el-input v-model="wechatComInfoObject.p73030" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="密钥::">
                        <el-input v-model="wechatComInfoObject.p73040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="进场通知模板::">
                        <el-input v-model="wechatComInfoObject.p73080" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出场通知模板::">
                        <el-input v-model="wechatComInfoObject.p73090" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="wechatComInfoObject.p73070" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="wechatComInfoObject.p73050" :disabled="!isEdit"
                          @change="changeEnable($event, 3)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="false">
                    <el-col :span="12">
                      <el-form-item label="参数定制::">
                        <el-radio-group v-model="wechatComInfoObject.p73091" :disabled="!isEdit">
                          <el-radio label="0">否</el-radio>
                          <el-radio label="1">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="APPLETPay">
              <span slot="label"><i class="el-icon-check" v-if="(AppletInfoObject.p73165 == '1')"></i>微信小程序</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="AppletPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="AppletPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="AppletPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="AppletPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="AppletPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="AppletPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>微信小程序
                  <el-link v-if="is_admin" href="https://wxpap.shangjieiot.com/#/login?redirect=%2Fdashboard"
                    type="danger" target="_blank">后台管理</el-link>
                </legend>
                <el-form :model="AppletInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="悟能APPID::">
                        <el-input v-model="AppletInfoObject.p73110" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="悟能APPKEY::">
                        <el-input v-model="AppletInfoObject.p73130" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="AppletInfoObject.p73115" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="发票连接::">
                        <el-input v-model="AppletInfoObject.p73150" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="悟能接口地址::">
                        <el-input v-model="AppletInfoObject.p73151" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="发送模板消息::">
                        <el-select v-model="AppletInfoObject.p73152" placeholder="请选择" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option label="否" value="0"></el-option>
                          <el-option label="是" value="1"></el-option>
                        </el-select>
                        <!-- <el-radio-group v-model="AppletInfoObject.p73152"
                                        :disabled="!isEdit">
                          <el-radio label="0">否</el-radio>
                          <el-radio label="1">是</el-radio>
                        </el-radio-group> -->
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场ID::">
                        <el-input v-model="AppletInfoObject.p73153" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="AppletInfoObject.p73165" @change="changeEnable($event, 8)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="alipayInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="alipayInfoObject.p74060 == '1' || aliSRObject.p74108 == '1'"></i> 支付宝</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="aliPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="aliPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="aliPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="aliPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="aliPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="aliPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>支付宝支付</legend>
                <el-form :model="alipayInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="alipayInfoObject.IsDefault" @change="setParams($event, 3)"
                          :disabled="!isEdit">
                          <el-radio :label="0">商秸参数</el-radio>
                          <el-radio :label="1">HT参数</el-radio>
                          <el-radio :label="-1">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付宝AppID::">
                        <el-input v-model="alipayInfoObject.p74010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="名称::">
                        <el-input v-model="alipayInfoObject.p74005" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="商户私钥::">
                        <el-input type="textarea" v-model="alipayInfoObject.p74030" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="支付宝公钥::">
                        <el-input type="textarea" v-model="alipayInfoObject.p74020" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="服务商PID::">
                        <el-input v-model="alipayInfoObject.p74001" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="授权token::">
                        <el-input v-model="alipayInfoObject.p74002" :disabled="!isEdit"
                          @input="changeAliParkToken($event, 1)" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="alipayInfoObject.p74040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付宝场库ID::">
                        <el-input v-model="alipayInfoObject.p74003" :disabled="!isEdit"
                          @input="changeAliParkID($event, 1)" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="alipayInfoObject.p74060" :disabled="!isEdit"
                          @change="changeEnable($event, 4)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="false">
                      <el-form-item label="参数定制::">
                        <el-radio-group v-model="alipayInfoObject.p74004" :disabled="!isEdit">
                          <el-radio label="0">否</el-radio>
                          <el-radio label="1">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>支付宝小程序</legend>
                <el-form :model="aliSRObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付宝AppID::">
                        <el-input v-model="aliSRObject.p74101" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="商户私钥::">
                        <el-input type="textarea" v-model="aliSRObject.p74102" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="支付宝公钥::">
                        <el-input type="textarea" v-model="aliSRObject.p74103" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="服务商PID::">
                        <el-input v-model="aliSRObject.p74104" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="授权token::">
                        <el-input v-model="aliSRObject.p74105" :disabled="!isEdit" @input="changeAliParkToken($event, 2)"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="aliSRObject.p74106" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付宝场库ID::">
                        <el-input v-model="aliSRObject.p74107" :disabled="!isEdit" @input="changeAliParkID($event, 2)"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="aliSRObject.p74108" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="商户PID::">
                        <el-input v-model="aliSRObject.p74109" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="BOCMWxPay">
              <span slot="label"><i class="el-icon-check" v-if="(BOCMWxInfoObject.p75080 == '1')"></i> 交行银联</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="BOCMWxPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="BOCMWxPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="BOCMWxPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="BOCMWxPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="BOCMWxPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="BOCMWxPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>基础参数</legend>
                <el-form :model="BOCMWxInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="BOCMWxInfoObject.p75020" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="AppKey::">
                        <el-input v-model="BOCMWxInfoObject.p75030" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="BOCMWxInfoObject.p75080" :disabled="!isEdit"
                          @change="changeEnable($event, 5)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>微信</legend>
                <el-form :model="BOCMWxInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="公众账号ID::">
                        <el-input v-model="BOCMWxInfoObject.p75010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="密钥::">
                        <el-input v-model="BOCMWxInfoObject.p75040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="进场通知模板::">
                        <el-input v-model="BOCMWxInfoObject.p75050" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出场通知模板::">
                        <el-input v-model="BOCMWxInfoObject.p75060" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="BOCMWxInfoObject.p75070" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>支付宝</legend>
                <el-form :model="BOCMWxInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付宝APPID::">
                        <el-input v-model="BOCMWxInfoObject.p75090" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="私钥::">
                        <el-input type="textarea" v-model="BOCMWxInfoObject.p75100" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="公钥::">
                        <el-input type="textarea" v-model="BOCMWxInfoObject.p75110" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="ICBCPay">
              <span slot="label"><i class="el-icon-check"
                  v-if="(ICBCInfoObject.p76090 == '1' || ICBCInfoObject.p76091 == '1')"></i> 工行支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="ICBCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="ICBCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="ICBCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="ICBCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="ICBCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="ICBCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>工行支付（C2B B2C 无感 无感绑定）</legend>
                <el-form :model="ICBCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="ICBCInfoObject.p76010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="私钥::">
                        <el-input type="textarea" v-model="ICBCInfoObject.p76020" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="公钥::">
                        <el-input type="textarea" v-model="ICBCInfoObject.p76030" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="C2B版本::">
                        <el-select v-model="ICBCInfoObject.p76094" :disabled="!isEdit" :clearable="true"
                          class="myParkInput" placeholder="请选择版本">
                          <el-option v-for="item in c2bUrlList" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="B2C版本::">
                        <el-select v-model="ICBCInfoObject.p76092" :disabled="!isEdit" :clearable="true"
                          class="myParkInput" placeholder="请选择版本">
                          <el-option v-for="item in b2cUrlList" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="无感支付版本::">
                        <el-select v-model="ICBCInfoObject.p76093" :disabled="!isEdit" :clearable="true"
                          class="myParkInput" placeholder="请选择版本">
                          <el-option v-for="item in platePayUrlList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <!-- <el-input v-model="ICBCInfoObject.p76093"
                                  :disabled="!isEdit"
                                  class="myParkInput"></el-input> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="无感签约版本::">
                        <el-select v-model="ICBCInfoObject.p76096" :disabled="!isEdit" :clearable="true"
                          class="myParkInput" placeholder="请选择版本">
                          <el-option v-for="item in plateUrlList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户档案编号::">
                        <el-input v-model="ICBCInfoObject.p76040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="e生活号::">
                        <el-input v-model="ICBCInfoObject.p76050" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户类型::">
                        <el-select v-model="ICBCInfoObject.p76080" :disabled="!isEdit" placeholder="请选择商户类型"
                          class="myParkInput">
                          <el-option v-for="item in merchantType" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="商户名称::">
                        <el-input v-model="ICBCInfoObject.p76060" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户入账账号::">
                        <el-input v-model="ICBCInfoObject.p76070" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="无感绑定AESKEY::">
                        <el-input v-model="ICBCInfoObject.p76095" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="ICBCInfoObject.p76090" :disabled="!isEdit"
                          @change="changeEnable($event, 6)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="无感启用状态::">
                        <el-radio-group v-model="ICBCInfoObject.p76091" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <div class="ICBCPay_tip">
                <div>成都新华宾馆
                  <ul>
                    <li> C2B版本:V2（默认）</li>
                    <li> B2C版本:V2（成都）</li>
                    <li> 无感支付版本:V3（成都)</li>
                    <li> 无感签约版本:V3（成都)</li>
                  </ul>
                </div>
                <div>
                  新高桥
                  <ul>
                    <li> C2B版本:V1（open.icbc.com.cn）</li>
                    <li> B2C版本:V2（open.icbc.com.cn）</li>
                  </ul>
                </div>
                <div>
                  江苏地震局
                  <ul>
                    <li> C2B版本:V1（open.icbc.com.cn）</li>
                  </ul>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="CGBPay">
              <span slot="label"><i class="el-icon-check" v-if="(CGBInfoObject.p77050 == '1')"></i> 威富通支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="CGBPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="CGBPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="CGBPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="CGBPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="CGBPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="CGBPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>威富通支付<span style="color:red">(RSA_1_1加密)</span></legend>
                <el-form :model="CGBInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="CGBInfoObject.p77010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="应用私钥::">
                        <el-input type="textarea" v-model="CGBInfoObject.p77020" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="平台公钥::">
                        <el-input type="textarea" v-model="CGBInfoObject.p77030" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="CGBInfoObject.p77040" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="CGBInfoObject.p77050" :disabled="!isEdit"
                          @change="changeEnable($event, 7)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="CGBNewPay">
              <span slot="label"><i class="el-icon-check" v-if="(CGBNewInfoObject.p77509 == '1')"></i> 广发新版支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="CGBNewPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="CGBNewPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="CGBNewPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="CGBNewPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="CGBNewPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="CGBNewPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>广发新版支付</legend>
                <el-form :model="CGBNewInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="合作伙伴ID::">
                        <el-input v-model="CGBNewInfoObject.p77501" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="应用ID::">
                        <el-input v-model="CGBNewInfoObject.p77502" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户ID::">
                        <el-input v-model="CGBNewInfoObject.p77503" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="版本号::">
                        <el-input v-model="CGBNewInfoObject.p77504" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="产品编号::">
                        <el-input v-model="CGBNewInfoObject.p77505" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付URL::">
                        <el-input v-model="CGBNewInfoObject.p77510" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="商户私钥::">
                        <el-input type="textarea" v-model="CGBNewInfoObject.p77506" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="商户公钥::">
                        <el-input type="textarea" v-model="CGBNewInfoObject.p77507" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="平台公钥::">
                        <el-input type="textarea" v-model="CGBNewInfoObject.p77508" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="CGBNewInfoObject.p77509" :disabled="!isEdit"
                          @change="changeEnable($event, 14)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="CCBPay">
              <span slot="label"><i class="el-icon-check"
                  v-if="(CCBInfoObject.p79070 == '1' || CCBInfoObject.p79080 == '1')"></i>建行支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="CCBPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="CCBPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="CCBPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="CCBPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="CCBPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="CCBPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>建行支付（C2B 无感）</legend>
                <el-form :model="CCBInfoObject" :inline="true" label-width="120px">
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="C2B公钥::">
                        <el-input type="textarea" v-model="CCBInfoObject.p79040" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="无感公钥::">
                        <el-input type="textarea" v-model="CCBInfoObject.p79050" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="CCBInfoObject.p79010" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="分行号::">
                        <el-input v-model="CCBInfoObject.p79030" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="C2B柜台号::">
                        <el-input v-model="CCBInfoObject.p79020" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="无感柜台号::">
                        <el-input v-model="CCBInfoObject.p79055" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="商户类型::">
                        <el-select v-model="CCBInfoObject.p79060" :disabled="!isEdit" placeholder="请选择商户类型"
                          class="myParkInput">
                          <el-option v-for="item in merchantType" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="CCBInfoObject.p79070" :disabled="!isEdit"
                          @change="changeEnable($event, 9)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="无感启用状态::">
                        <el-radio-group v-model="CCBInfoObject.p79080" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="C2B回调地址::" class="btn_copy_content">
                        <el-input :disabled="true" style="width:500px" :value="CCBCallbackUrl"></el-input>
                        <el-button type="warning" class="CCBCallbackUrl_btn" :data-clipboard-text='CCBCallbackUrl'
                          @click="copy($event, 'CCBCallbackUrl_btn')">复制</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="YunZongInfo">
              <span slot="label"><i class="el-icon-check" v-if="(YunZongInfoObject.p78490 == '1')"></i>云纵支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="YunZongPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="YunZongPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="YunZongPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="YunZongPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="YunZongPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="YunZongPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>云纵支付（C2B B2C）</legend>
                <el-form :model="YunZongInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="YunZongInfoObject.IsDefault" @change="setParams($event, 5)"
                          :disabled="!isEdit">
                          <el-radio :label="true">商秸参数</el-radio>
                          <el-radio :label="false">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="机构号::">
                        <el-input v-model="YunZongInfoObject.p78410" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="YunZongInfoObject.p78420" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场ID::">
                        <el-input v-model="YunZongInfoObject.p78430" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付地址::">
                        <el-select v-model="YunZongInfoObject.p78440" :disabled="!isEdit" class="myParkInput"
                          placeholder="请选择版本">
                          <el-option v-for="item in yzUrlList" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付版本号::">
                        <el-select v-model="YunZongInfoObject.p78450" :disabled="!isEdit" class="myParkInput"
                          placeholder="请选择版本">
                          <el-option v-for="item in yzVerList" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="云纵公钥::">
                        <el-input type="textarea" v-model="YunZongInfoObject.p78460" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="软杰私钥::">
                        <el-input type="textarea" v-model="YunZongInfoObject.p78470" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="软杰公钥::">
                        <el-input type="textarea" v-model="YunZongInfoObject.p78480" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="YunZongInfoObject.p78490" :disabled="!isEdit"
                          @change="changeEnable($event, 10)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="SPDPay">
              <span slot="label"><i class="el-icon-check" v-if="(SPDInfoObject.p79109 == '1')"></i> 浦发支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="SPDPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="SPDPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="SPDPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="SPDPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="SPDPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="SPDPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>浦发支付（C2B B2C）</legend>
                <el-form :model="SPDInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="参数::">
                        <el-radio-group v-model="YunZongInfoObject.IsDefault" @change="setParams($event, 6)"
                          :disabled="!isEdit">
                          <el-radio :label="true">商秸参数</el-radio>
                          <el-radio :label="false">无参数</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="软杰私钥::">
                        <el-input type="textarea" v-model="SPDInfoObject.p79113" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="软杰公钥::">
                        <el-input type="textarea" v-model="SPDInfoObject.p79112" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="私钥::">
                        <el-input type="textarea" v-model="SPDInfoObject.p79103" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="公钥::">
                        <el-input type="textarea" v-model="SPDInfoObject.p79104" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="版本号::">
                        <el-select v-model="SPDInfoObject.p79101" :disabled="!isEdit" placeholder="请选择版本号"
                          class="myParkInput">
                          <el-option v-for="item in spdVerList" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端地址::">
                        <el-input v-model="SPDInfoObject.p79110" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="SPDInfoObject.p79102" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="用户::">
                        <el-input v-model="SPDInfoObject.p79106" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="子用户::">
                        <el-input v-model="SPDInfoObject.p79107" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="微信APPID::">
                        <el-input v-model="SPDInfoObject.p79108" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="微信AppSecret::">
                        <el-input v-model="SPDInfoObject.p79111" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="SPDInfoObject.p79105" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SPDInfoObject.p79109" :disabled="!isEdit"
                          @change="changeEnable($event, 11)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="ABCPay">
              <span slot="label"><i class="el-icon-check" v-if="(ABCInfoObject.p79158 == '1')"></i> 苏州农行支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="ABCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="ABCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="ABCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="ABCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="ABCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="ABCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>苏州农行支付（C2B）</legend>
                <el-form :model="ABCInfoObject" :inline="true" label-width="120px">
                  <!-- <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="公钥::">
                        <el-input type="textarea"
                                  v-model="ABCInfoObject.p79104"
                                  :disabled="!isEdit"
                                  class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row> -->
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="密钥1::">
                        <el-input v-model="ABCInfoObject.p79152" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="密钥2::">
                        <el-input v-model="ABCInfoObject.p79153" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="用户::">
                        <el-input v-model="ABCInfoObject.p79154" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="方法::">
                        <el-input v-model="ABCInfoObject.p79155" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="ABCInfoObject.p79156" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="子商户号::">
                        <el-input v-model="ABCInfoObject.p79157" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="ABCInfoObject.p79151" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="ABCInfoObject.p79158" :disabled="!isEdit"
                          @change="changeEnable($event, 13)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="saobeiInfo">
              <span slot="label"><i class="el-icon-check" v-if="saobeiInfoObject.p79185 == '1'"></i> 扫呗支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="saobeiPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="saobeiPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="saobeiPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="saobeiPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="saobeiPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="saobeiPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>扫呗支付</legend>
                <el-form :model="saobeiInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="saobeiInfoObject.p79181" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端号::">
                        <el-input v-model="saobeiInfoObject.p79182" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="令牌::">
                        <el-input v-model="saobeiInfoObject.p79183" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="saobeiInfoObject.p79184" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="saobeiInfoObject.p79185" :disabled="!isEdit"
                          @change="changeEnable($event, 15)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="SHJBHPayInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(SHJBHPayInfo.p94147 == '1') || (SHJBHPayInfo1.p941406 == '1')"></i>上海停车APP</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  上海停车APP参数设置
                </legend>
                <el-form :model="SHJBHPayInfo" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="场库 id::">
                        <el-input v-model="SHJBHPayInfo.p94141" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="接入账号::">
                        <el-input v-model="SHJBHPayInfo.p94142" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="接入密码::">
                        <el-input v-model="SHJBHPayInfo.p94143" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="IP或域名::">
                        <el-input v-model="SHJBHPayInfo.p94144" :disabled="!isEdit" class="myParkInput"></el-input>
                        说明：包含http或https
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="端口号::">
                        <el-input v-model="SHJBHPayInfo.p94145" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SHJBHPayInfo.p94147" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>

                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="进博会模式::">
                        <el-radio-group v-model="SHJBHPayInfo.p94148" :disabled="!isEdit">
                          <el-radio label="0">无效</el-radio>
                          <el-radio label="1">有效(自动修改预约时间至一天有效)</el-radio>
                        </el-radio-group>
                      </el-form-item>

                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="无感状态::">
                        <el-radio-group v-model="SHJBHPayInfo.p94139" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>

                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="结果::">
                        <el-input type="textarea" v-model="SHJBHPayInfo.p94149" :disabled="true"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend style="padding-top: 10px">
                  上海公共停车平台参数设置
                </legend>
                <el-form :model="SHJBHPayInfo1" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="SHJBHPayInfo1.p941401" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="场库 id::">
                        <el-input v-model="SHJBHPayInfo1.p941403" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="IP或域名::">
                        <el-input v-model="SHJBHPayInfo1.p941404" :disabled="!isEdit" class="myParkInput"></el-input>
                        说明：包含http或https
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="端口号::">
                        <el-input v-model="SHJBHPayInfo1.p941405" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="接入密码::">
                        <el-input v-model="SHJBHPayInfo1.p941402" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SHJBHPayInfo1.p941406" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="SHCardPayInfo">
              <span slot="label"><i class="el-icon-check" v-if="(SHCardPayInfo.p94156 == '1')"></i>上海公交卡P+R</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  上海公交卡P+R参数设置
                </legend>
                <el-form :model="SHCardPayInfo" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="服务器IP::">
                        <el-input v-model="SHCardPayInfo.p94151" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="服务器端口::">
                        <el-input v-model="SHCardPayInfo.p94152" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="psam卡号::">
                        <el-input v-model="SHCardPayInfo.p94153" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="公司代码::">
                        <el-input v-model="SHCardPayInfo.p94154" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="POS程序名称::">
                        <el-input v-model="SHCardPayInfo.p94155" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SHCardPayInfo.p94156" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>

                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="GRGPay">
              <span slot="label"><i class="el-icon-check" v-if="(GRGInfoObject.p79205 == '1')"></i> 广电运通支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="GRGPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="GRGPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="GRGPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="GRGPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="GRGPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="GRGPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>广电运通支付<span style="color:red">(RSA_1_1加密)</span></legend>
                <el-form :model="GRGInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="GRGInfoObject.p79201" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="应用私钥::">
                        <el-input type="textarea" v-model="GRGInfoObject.p79202" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="平台公钥::">
                        <el-input type="textarea" v-model="GRGInfoObject.p79203" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="GRGInfoObject.p79204" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="GRGInfoObject.p79205" :disabled="!isEdit"
                          @change="changeEnable($event, 16)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="AHSRCBPayInfo">
              <span slot="label"><i class="el-icon-check" v-if="(AHSRCBPayInfoObject.p79405 == '1')"></i> 安徽农商支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="AHSRCBPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="AHSRCBPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="AHSRCBPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="AHSRCBPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="AHSRCBPayReg.fEndDate" :disabled="!isEdit" type="date"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="AHSRCBPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>安徽农商支付<span style="color:red">（此支付通道不支持私有停车云平台）</span></legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="AHSRCBPayInfoObject.p79401" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端号::">
                        <el-input v-model="AHSRCBPayInfoObject.p79402" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="AHSRCBPayInfoObject.p79403" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPKEY::">
                        <el-input v-model="AHSRCBPayInfoObject.p79404" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="AHSRCBPayInfoObject.p79405" :disabled="!isEdit"
                          @change="changeEnable($event, 17)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="回调接口::">
                        <el-input v-model="AHSRCBPayInfoObject.p79406" :disabled="!isEdit"
                          class="myParkInput"></el-input>(一定要用19080端口)
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="MOBOBPayInfo">
              <span slot="label"><i class="el-icon-check" v-if="(mobobInfoObject.p79504 == '1')"></i> 墨博无感支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="mobobPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="mobobPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="mobobPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="mobobPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="mobobPayReg.fEndDate" :disabled="!isEdit" type="date"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="mobobPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>墨博无感支付</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="AppKey::">
                        <el-input v-model="mobobInfoObject.p79502" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="AppSecret::">
                        <el-input v-model="mobobInfoObject.p78503" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="mobobInfoObject.p79501" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="mobobInfoObject.p79504" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="FMInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(FMInfo.p94132 == '1' || TeslaInfoObject.p79603 == '1' || CubeInfoObject.p79652 == '1'|| SamsClubInfoObject.p94303 == '1')"></i>
                第三方支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  第三方支付
                </legend>
                <el-form :model="FMInfo" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="直付/无感链接::">
                        <el-input v-model="FMInfo.p94131" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="FMInfo.p94132" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>

              <fieldset>
                <legend style="padding-top: 10px">
                  特斯拉优惠券下发
                </legend>
                <el-form :model="TeslaInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="ServiceAccount::">
                        <el-input v-model="TeslaInfoObject.p79602" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="TeslaInfoObject.p79603" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="PublicKey::">
                        <el-input type="textarea" v-model="TeslaInfoObject.p79601" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top:30px">
                    <el-col :span="24">
                      <el-form-item label="接口调用地址::">
                        <el-input v-model="TeslaInfoObject.p79604" :disabled="true" class="interfaceAPI"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="场库ID::">
                        <el-input v-model="TeslaInfoObject.p79605" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="场库名称::">
                        <el-input v-model="TeslaInfoObject.p79606" :disabled="true" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend style="padding-top: 10px">
                  立方支付(http协议2.1.2版)
                </legend>
                <el-form :model="CubeInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="接口调用地址::">
                        <el-input v-model="CubeInfoObject.p79651" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="CubeInfoObject.p79652" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend style="padding-top: 10px">
                  山姆优惠券下发(北京兴创)
                </legend>
                <el-form :model="SamsClubInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="最低金额限制::">
                        <el-input v-model="SamsClubInfoObject.p94301" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="抵扣分钟数::">
                        <el-input v-model="SamsClubInfoObject.p94302" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SamsClubInfoObject.p94303" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="CQETCPay" v-if="false">
              <span slot="label"><i class="el-icon-check" v-if="(CQETCInfoObject.p78150 == '1')"></i>特微ETC</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="CQETCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="CQETCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="CQETCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="CQETCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="CQETCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="CQETCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>特微ETC结算</legend>
                <el-form :model="CQETCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="省域编码::">
                        <el-input v-model="CQETCInfoObject.p78110" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="停车场业主编码::">
                        <el-input v-model="CQETCInfoObject.p78120" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场编号::">
                        <el-input v-model="CQETCInfoObject.p78130" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="清分结算URL::">
                        <el-input v-model="CQETCInfoObject.p78140" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="签名密钥::">
                        <el-input v-model="CQETCInfoObject.p78141" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="CQETCInfoObject.p78150" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="QTETCInfo" v-if="false">
              <span slot="label"><i class="el-icon-check" v-if="(QTETCInfoObject.p78240 == '1')"></i>黔通ETC</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="QTETCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="QTETCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="QTETCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="QTETCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="QTETCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="QTETCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>黔通ETC数据上传</legend>
                <el-form :model="QTETCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="URL地址::">
                        <el-input v-model="QTETCInfoObject.p78210" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="接入码::">
                        <el-input v-model="QTETCInfoObject.p78220" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="签名码::">
                        <el-input v-model="QTETCInfoObject.p78230" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="QTETCInfoObject.p78240" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="LZETCPay">
              <span slot="label"><i class="el-icon-check" v-if="(SHETCInfoObject.p78640 == '1')"></i>上海公交卡ETC</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="SHETCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="SHETCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="SHETCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="SHETCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="SHETCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="SHETCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>上海公交卡数据上传</legend>
                <el-form :model="SHETCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="交易上送URL::">
                        <el-input v-model="SHETCInfoObject.p78650" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">

                      <el-form-item label="渠道号::">
                        <el-input v-model="SHETCInfoObject.p78660" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="停车场服务商::">
                        <el-input v-model="SHETCInfoObject.p78620" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="停车场库编号::">
                        <el-input v-model="SHETCInfoObject.p78630" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="key(加签)::">
                        <el-input v-model="SHETCInfoObject.p78670" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="交易的文字描述::">
                        <el-input v-model="SHETCInfoObject.p78610" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="证书编号(p12)::">
                        <el-input v-model="SHETCInfoObject.p78680" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="证书密码::">
                        <el-input v-model="SHETCInfoObject.p78690" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SHETCInfoObject.p78640" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="MYZXETCPay">
              <span slot="label"><i class="el-icon-check" v-if="(MYZXETCInfoObject.p78730 == '1')"></i>蚂蚁智行ETC</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="MYZXETCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="MYZXETCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="MYZXETCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="MYZXETCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="MYZXETCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="MYZXETCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>蚂蚁智行ETC数据上传</legend>
                <el-form :model="MYZXETCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="服务商编码::">
                        <el-input v-model="MYZXETCInfoObject.p78710" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="密钥::">
                        <el-input v-model="MYZXETCInfoObject.p78720" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="MYZXETCInfoObject.p78730" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="HTETCPay">
              <span slot="label"><i class="el-icon-check" v-if="(HTETCInfoObject.p78804 == '1')"></i>辉通ETC</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="HTETCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="HTETCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="HTETCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="HTETCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="HTETCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="HTETCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>辉通ETC数据上传</legend>
                <el-form :model="HTETCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="场库ID::">
                        <el-input v-model="HTETCInfoObject.p78801" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="密钥::">
                        <el-input v-model="HTETCInfoObject.p78802" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="回调地址::">
                        <el-input v-model="HTETCInfoObject.p78803" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="HTETCInfoObject.p78804" @change="changeEnable($event, 12)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="SZSFETCPay">
              <span slot="label"><i class="el-icon-check" v-if="(SZSFETCInfoObject.p78904 == '1')"></i>深圳卅非ETC</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="SZSFETCPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="SZSFETCPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="SZSFETCPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="SZSFETCPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="SZSFETCPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="SZSFETCPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>深圳卅非ETC支付</legend>
                <el-form :model="SZSFETCInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="AppID::">
                        <el-input v-model="SZSFETCInfoObject.p78901" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="私钥::">
                        <el-input v-model="SZSFETCInfoObject.p78902" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="平台地址::">
                        <el-input v-model="SZSFETCInfoObject.p78903" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="SZSFETCInfoObject.p78904" @change="changeEnable($event, 12)"
                          :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="NYCRMInfo">
              <span slot="label"><i class="el-icon-check" v-if="(NYCRMInfo.p93330 == '1')"></i> 诺亚CRM</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  诺亚CRM
                </legend>
                <el-form :model="NYCRMInfo" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="CRM注册码::">
                        <el-input v-model="NYCRMInfo.p93320" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="NYCRMInfo.p93330" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="接口地址::">
                        <el-input v-model="NYCRMInfo.p93310" :disabled="!isEdit" style="width:500px"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="JGDTInfo" v-if="false">
              <span slot="label"><i class="el-icon-check" v-if="(JGDTInfo.p93353 == '1')"></i> 建工大唐</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  建工大唐积分抵扣
                </legend>
                <el-form :model="JGDTInfo" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPKey::">
                        <el-input v-model="JGDTInfo.p93354" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPSecret::">
                        <el-input v-model="JGDTInfo.p93355" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="获取优惠券地址::">
                        <el-input v-model="JGDTInfo.p93351" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="核销优惠券地址::">
                        <el-input v-model="JGDTInfo.p93352" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="JGDTInfo.p93353" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>

                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>

            <el-tab-pane name="NBYSInfo">
              <span slot="label"><i class="el-icon-check" v-if="(NBYSInfo.p93640 == '1')"></i> 一咻设置</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  一咻设置
                </legend>
                <el-form :model="NBYSInfo" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="请求方::">
                        <el-input v-model="NBYSInfo.p93610" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="NBYSInfo.p93640" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="接口地址::">
                        <el-input v-model="NBYSInfo.p93630" :disabled="!isEdit" style="width:500px"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Key::">
                        <el-input v-model="NBYSInfo.p93620" :disabled="!isEdit" style="width:500px"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="YunZongADInfo">
              <span slot="label"><i class="el-icon-check" v-if="(YunZongADInfoObject.p78590 == '1')"></i>云纵广告</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  注册信息
                </legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册方式::">
                        <el-select v-model="YunZongADPayReg.fRegType" placeholder="请选择方式" :disabled="!isEdit"
                          class="myParkInput">
                          <el-option v-for="item in regTypeList" :key="item.value" :label="item.text" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="注册用户::">
                        <el-input v-model="YunZongADPayReg.fLinkman" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话::">
                        <el-input v-model="YunZongADPayReg.fLinkPhone" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="有效起始时间::">
                        <el-date-picker v-model="YunZongADPayReg.fStartDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效起始时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效结束时间::">
                        <el-date-picker v-model="YunZongADPayReg.fEndDate" type="date" :disabled="!isEdit"
                          placeholder="选择有效结束时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注::">
                        <el-input v-model="YunZongADPayReg.fRemark" style="width:500px" :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend style="color:red">云纵广告参数</legend>
                <el-form :model="YunZongADInfoObject" :inline="true" label-width="140px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="Banner广告::">
                        <el-input v-model="YunZongADInfoObject.p78510" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="直跳广告::">
                        <el-input v-model="YunZongADInfoObject.p78520" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <legend style="color:red">Banner广告请求参数(服务端请求时以下两个参数必填)</legend>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="客户端IP::">
                        <el-input v-model="YunZongADInfoObject.p78530" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户端User-Agent::">
                        <el-input v-model="YunZongADInfoObject.p78540" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="YunZongADInfoObject.p78590" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="PYUNInfo">
              <span slot="label"><i class="el-icon-check" v-if="(PYUNInfoObject.p99952 == '1')"></i>PYun广告</span>
              <fieldset>
                <legend>PYun广告参数</legend>
                <el-form :model="PYUNInfoObject" :inline="true" label-width="140px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="appid::">
                        <el-input v-model="PYUNInfoObject.p99951" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="PYUNInfoObject.p99952" :disabled="!isEdit">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="AHZFYPay">
              <span slot="label"><i class="el-icon-check" v-if="(AHZFYInfoObject.p79709 == '1')"></i> 智付云支付</span>
              <fieldset>
                <legend style="padding-top: 10px">智付云支付(安徽黄山银联)</legend>
                <el-form :model="AHZFYInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="AHZFYInfoObject.p79702" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端设备号::">
                        <el-input v-model="AHZFYInfoObject.p79710" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="经度::">
                        <el-input v-model="AHZFYInfoObject.p79711" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="维度::">
                        <el-input v-model="AHZFYInfoObject.p79712" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="私钥::">
                        <el-input type="textarea" v-model="AHZFYInfoObject.p79705" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="公钥::">
                        <el-input type="textarea" v-model="AHZFYInfoObject.p79704" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="AHZFYInfoObject.p79703" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="AHZFYInfoObject.p79709" :disabled="!isEdit"
                          @change="changeEnable($event, 18)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="chinaUnionPayInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(chinaUnionPayInfoObject.p79809 == '1' || chinaUnionPayInfoObject.p79810 == '1')"></i>
                中国银联</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  公共信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="chinaUnionPayInfoObject.p79801" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端设备编号::">
                        <el-input v-model="chinaUnionPayInfoObject.p79802" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="子商户::">
                        <el-input v-model="chinaUnionPayInfoObject.p79803" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="chinaUnionPayInfoObject.p79804" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="经度::">
                        <el-input v-model="chinaUnionPayInfoObject.p79806" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="纬度::">
                        <el-input v-model="chinaUnionPayInfoObject.p79807" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="商户密钥::">
                        <el-input v-model="chinaUnionPayInfoObject.p79811" style="width:500px"
                          :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="支付链接::">
                        <el-input v-model="chinaUnionPayInfoObject.p79808" style="width:500px"
                          :disabled="!isEdit"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>中国银联BtoC设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="chinaUnionPayInfoObject.p79809" :disabled="!isEdit"
                          @change="changeEnable($event, 19)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>中国银联CtoB设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="chinaUnionPayInfoObject.p79810" :disabled="!isEdit"
                          @change="changeEnable($event, 19)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="CSRCBPayInfo">
              <span slot="label"><i class="el-icon-check" v-if="(CSRCBPayInfoObject.p79911 == '1')"></i> 常熟农商行支付</span>
              <fieldset>
                <legend style="padding-top: 10px">常熟农商行支付</legend>
                <el-form :model="CSRCBPayInfoObject" :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号(H5专用)::">
                        <el-input v-model="CSRCBPayInfoObject.p79901" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="终端设备号::">
                        <el-input v-model="CSRCBPayInfoObject.p79903" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="经度::">
                        <el-input v-model="CSRCBPayInfoObject.p79904" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="维度::">
                        <el-input v-model="CSRCBPayInfoObject.p79905" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="CSRCBPayInfoObject.p79906" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPKEY::">
                        <el-input v-model="CSRCBPayInfoObject.p79907" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="私钥(文件名以.pfx结尾)::">
                        <el-input type="textarea" v-model="CSRCBPayInfoObject.p79908" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="fRemark_row">
                    <el-col :span="24">
                      <el-form-item label="公钥(文件名以.cer结尾)::">
                        <el-input type="textarea" v-model="CSRCBPayInfoObject.p79909" :disabled="!isEdit"
                          class="parkTextArea"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="证书密码::">
                        <el-input v-model="CSRCBPayInfoObject.p79912" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="CSRCBPayInfoObject.p79910" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="CSRCBPayInfoObject.p79911" :disabled="!isEdit"
                          @change="changeEnable($event, 20)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
            <el-tab-pane name="PYunPayInfo">
              <span slot="label"><i class="el-icon-check"
                  v-if="(PYunPayInfoObject.p94174 == '1' || PYunPayInfoObject.p94175 == '1')"></i>
                PYun支付</span>
              <fieldset>
                <legend style="padding-top: 10px">
                  公共信息
                </legend>
                <el-form label-width="120px" :inline="true">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="商户号::">
                        <el-input v-model="PYunPayInfoObject.p94173" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="APPID::">
                        <el-input v-model="PYunPayInfoObject.p94171" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="秘钥::">
                        <el-input v-model="PYunPayInfoObject.p94172" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="支付链接::">
                        <el-input v-model="PYunPayInfoObject.p94176" :disabled="!isEdit" class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>PYun支付BtoC设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="PYunPayInfoObject.p94175" :disabled="!isEdit"
                          @change="changeEnable($event, 21)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
              <fieldset>
                <legend>PYun支付CtoB设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="PYunPayInfoObject.p94174" :disabled="!isEdit"
                          @change="changeEnable($event, 21)">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <el-row style="margin-top:-1px">
          <el-col :span="12">
            <div class="tab_foot">&nbsp;</div>
            <div class="btn_foot">
              <!-- <el-button type="success"
                         @click="setParams"
                         v-if="isEdit">商秸参数</el-button>
              <el-button type="info"
                         @click="clearParams"
                         v-if="isEdit">清空参数</el-button> -->
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-footer">
              <el-button type="primary" @click="submitForm('form')" v-if="isEdit" :loading="save_loading">{{ save_msg
              }}</el-button>
              <el-button @click="parkEditOrDetailVisible = false">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
import * as user from '../../api/user'
import * as park from '../../api/park'
import Clipboard from 'clipboard'
export default {
  name: 'payOnline',
  data () {
    return {
      export_msg: '导出微信支付宝参数',
      export_loading: false,
      navigationMap: {
        parkList: '场库列表',
        synParkList: '待同步'
      },
      payTypeList: [
        { label: '银联', value: '71000-71060,71190,71350' },
        { label: '银联数字货币', value: '71400-71409,71426' },
        { label: '微信服务商', value: '72000-72070,72120,72182,72183,72190-72192' },
        { label: '微信公众号', value: '73000-73050' },
        { label: '支付宝', value: '74000-74060' },
        { label: '支付宝小程序', value: '74100-74108' },
        { label: '交行银联', value: '75000-75080' },
        { label: '工行', value: '76000-76090,76091' },
        { label: '威富通支付', value: '77000-77050' },
        { label: '新版广发支付', value: '77500-77509' },
        { label: '微信小程序', value: '73100-73165' },
        { label: '诺亚CRM', value: '93300-93330' },
        { label: '建工大唐', value: '93350-93353' },
        { label: '第三方支付', value: '94130-94132' },
        { label: '特斯拉优惠券', value: '79600-79603' },
        { label: '立方支付', value: '79650-79652' },
        { label: '山姆优惠券', value: '94300-94303' },
        { label: '一咻', value: '93600-93640' },
        { label: '建行支付', value: '79000-79070,79080' },
        { label: '云纵支付', value: '78400-78490' },
        { label: '浦发支付', value: '79100-79109' },
        { label: '农行支付', value: '79150-79158' },
        { label: '扫呗支付', value: '79180-79185' },
        { label: '广电运通支付', value: '79200-79205' },
        { label: '蚂蚁智行支付', value: '79300-79306' },
        { label: '安徽农商支付', value: '79400-79406' },
        { label: '云纵广告', value: '78500-78590' },
        { label: '泊斯特广告', value: '78550-78558' },
        { label: '泊斯特广告2.0', value: '78570-78578' },
        { label: 'PYUN广告', value: '99950-99952' },
        { label: '上海停车APP', value: '94140-94147,94139' },
        { label: '上海公交卡P+R', value: '94150-94156' },
        { label: '易米ETC', value: '78100-78150' },
        { label: '黔通ETC', value: '78200-78240' },
        { label: '上海公交卡ETC', value: '78600-78640' },
        { label: '辉通ETC', value: '78800-78804' },
        { label: '蚂蚁智行ETC', value: '78700-78730' },
        { label: '深圳卅非ETC', value: '78900-78904' },
        { label: '容津发票', value: '99100-99160' },
        { label: 'E开票', value: '99200-99299' },
        { label: '银联发票', value: '99500-99519' },
        { label: '高灯发票', value: '99600-99607' },
        { label: '墨博无感', value: '79500-79504' },
        { label: '航信发票', value: '99700-99701' },
        { label: '航天诺诺发票', value: '99800-99808' },
        { label: '诺诺发票自用型', value: '99850-99861' },
        { label: '智付云支付', value: '79700-79705,79709' },
        { label: '中国银联支付', value: '79800-79808,79809,79810' },
        { label: '常熟农商行', value: '79900-79910,79911' },
        { label: 'PYun支付', value: '94170-94176' },
        { label: '北京航天电子发票', value: '99900-99915' }
      ],
      flagTemp: false,
      selPayType: [],
      init_loading: false,
      inittwo_loading: false,
      save_loading: false,
      save_msg: '保存',
      loading: false,
      is_edit: false,
      is_export: false,
      is_del: false,
      is_syn: false,
      is_admin: false,
      pay_url: '',
      parkActiveName: 'parkList',
      regTypeList: [{ text: '公司代理', value: '0' }, { text: '用户注册', value: '1' }],
      merchantType: [{ label: '线上POS档案商户', value: '1' }, { label: '线下POS档案商户', value: '2' }, { label: '深圳行商户', value: '3' }],
      c2bUrlList: [
        { label: 'V2（默认）', value: 'https://gw.open.icbc.com.cn/api/qrcode/V2/generate' },
        { label: 'V1（open.icbc.com.cn）', value: 'https://gw.open.icbc.com.cn/api/cardbusiness/qrcode/qrgenerate/V1' }
      ],
      b2cUrlList: [
        { label: 'V4（默认）', value: 'https://gw.open.icbc.com.cn/api/qrcode/pay/V4' },
        { label: 'V2（成都）', value: 'https://gw.open.icbc.com.cn/api/qrcode/V2/pay' },
        { label: 'V2（open.icbc.com.cn）', value: 'https://gw.open.icbc.com.cn/api/mybank/pay/qrcode/scanned/pay/V2' },
        { label: 'V1（open.icbc.com.cn）', value: 'https://gw.open.icbc.com.cn/api/mybank/pay/qrcode/scanned/pay/V1' }
      ],
      platePayUrlList: [{ label: 'V1（open.icbc.com.cn）', value: 'https://gw.open.icbc.com.cn/api/b2c/licenseplate/payment/pay/V1' }, { label: 'V3（成都）', value: 'https://gw.open.icbc.com.cn/api/b2c/licenseplate/payment/pay/V3' }],
      plateUrlList: [{ label: 'V3（成都）', value: 'https://gw.open.icbc.com.cn/ui/b2c/ui/licenseplate/payment/agreement/V3' }],
      yzUrlList: [{ label: 'V2（默认）', value: 'https://po.yunzongnet.com/api/v2/gateway' }],
      yzVerList: [{ label: '2.0（默认）', value: '2.0' }],
      spdVerList: [{ label: '1.0（默认）', value: '1.0.0' }],
      unionPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      aliPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      weChatComPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      saobeiPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      weChatSvrPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      BOCMWxPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      ICBCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CGBPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CGBNewPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CCBPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      SPDPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      ABCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CQETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      QTETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      SHETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      MYZXETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      HTETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      SZSFETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      YunZongPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      YunZongADPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      BSTADReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      AppletPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      GRGPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      mobobPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      BSTInfoObject: {
        p78551: '',
        p78552: '',
        p78553: '',
        p78554: '',
        p78555: '',
        p78556: '',
        p78557: '',
        p78558: '0'
      },
      BSTTwoInfoObject: {
        p78571: '',
        p78572: '',
        p78573: '',
        p78574: '',
        p78575: '',
        p78576: '',
        p78577: '',
        p78578: '0',
        p78579: ''
      },
      PYUNInfoObject: {
        p99951: '',
        p99952: '0'
      },
      HTInvoiceObject: {
        p99801: '',
        p99802: 'https://nnfp.jss.com.cn',
        p99803: '',
        p99809: '停车服务费',
        p99804: '',
        p99805: '',
        p99806: '',
        p99807: '30',
        p99808: '0',
        p99810: '',
        p99811: '',
        p99812: '',
        p99813: '',
        p99814: '',
        p99815: '',
        p99816: '',
        p99817: '',
        p99818: '',
        p99819: ''
      },
      TJHTInvObject: {
        p99851: '',
        p99852: '',
        p99853: '',
        p99854: '',
        p99855: '',
        p99856: '',
        p99857: '停车服务费',
        p99858: '',
        p99859: 'https://sdk.nuonuo.com/open/v1/services',
        p99860: '30',
        p99861: '0'
      },
      unionEInvoiceObject: {
        p99501: '',
        p99502: '',
        p99503: '',
        p99504: '',
        p99505: '',
        p99506: '',
        p99507: '',
        p99508: '30',
        p99509: '5',
        p99510: '',
        p99511: '',
        p99512: '',
        p99513: '',
        p99514: '',
        p99515: '',
        p99516: '',
        p99517: '',
        p99518: '车辆停放服务',
        p99519: '3040502020200000000'
      },
      gdEInvoiceObject: {
        p99601: '',
        p99602: '',
        p99603: '',
        p99604: '',
        p99605: '',
        p99606: '',
        p99607: '',
        p99611: '30',
        p99608: '',
        p99609: '',
        p99610: 'http://einvapi.shangjieiot.com:8081/EInv/Invoice/QueryByCode'
      },
      HXInvoiceObject: {
        p99701: '0',
        p99702: '',
        p99703: '',
        p99704: '',
        p99705: '',
        p99706: '',
        p99707: '',
        p99708: '',
        p99709: '',
        p99710: '',
        p99711: '',
        p99712: '0',
        p99713: '30',
        p99714: ''
      },
      CGBInfoObject: {
        p77010: '',
        p77020: '',
        p77030: '',
        p77040: '',
        p77050: ''
      },
      CGBNewInfoObject: {
        p77501: '',
        p77502: '',
        p77503: '',
        p77504: '',
        p77505: '',
        p77506: '',
        p77507: '',
        p77508: '',
        p77509: '',
        p77510: ''
      },
      NYCRMInfo: {
        p93310: '',
        p93320: '',
        p93330: ''
      },
      JGDTInfo: {
        p93351: '',
        p93352: '',
        p93353: '',
        p93354: '',
        p93355: ''
      },
      SHJBHPayInfo: {
        p94141: '',
        p94142: '',
        p94143: '',
        p94144: 'http://parkzhtc.jtcx.sh.cn',
        p94145: '80',
        p94147: '',
        p94148: '0',
        p94139: '0',
        p94149: ''
      },
      SHJBHPayInfo1: {
        p941401: '',
        p941402: '',
        p941403: '',
        p941404: 'http://parkzhtc.jtcx.sh.cn',
        p941405: '80',
        p941406: '0'
      },
      SHCardPayInfo: {
        p94151: '',
        p94152: '',
        p94153: '',
        p94154: '',
        p94155: '',
        p94156: ''
      },
      FMInfo: {
        p94131: '',
        p94132: ''
      },
      NBYSInfo: {
        p93610: '',
        p93620: '',
        p93630: '',
        p93640: ''
      },
      ICBCInfoObject: {
        p76010: '',
        p76020: '',
        p76030: '',
        p76040: '',
        p76050: '',
        p76060: '',
        p76070: '',
        p76080: '',
        p76090: '',
        p76091: '',
        p76092: '',
        p76093: '',
        p76094: '',
        p76095: '',
        p76096: ''
      },
      CCBInfoObject: {
        p79010: '',
        p79020: '',
        p79030: '',
        p79040: '',
        p79050: '',
        p79055: '',
        p79060: '',
        p79070: '',
        p79080: ''
      },
      SPDInfoObject: {
        p79100: '',
        p79101: '',
        p79102: '',
        p79103: '',
        p79104: '',
        p79105: '',
        p79106: '',
        p79107: '',
        p79108: '',
        p79109: '',
        p79110: '',
        p79111: '',
        p79112: '',
        p79113: ''
      },
      ABCInfoObject: {
        p79150: '',
        p79151: '',
        p79152: '',
        p79153: '',
        p79154: '',
        p79155: '',
        p79156: '',
        p79157: '',
        p79158: ''
      },
      RJInvoiceObject: {
        p99110: '',
        p99120: '',
        p99130: '',
        p99140: '',
        p99150: '',
        p99160: '',
        p99151: '30',
        p99152: '',
        p99153: ''
      },
      EInvoiceObject: {
        p99210: '',
        p99220: '',
        p99230: '',
        p99240: '',
        p99250: '',
        p99260: '',
        p99270: '',
        p99280: '',
        p99290: '',
        p99291: '30',
        p99299: ''
      },
      BOCMWxInfoObject: {
        p75010: '',
        p75020: '',
        p75030: '',
        p75040: '',
        p75050: '',
        p75060: '',
        p75070: '',
        p75080: '',
        p75090: '',
        p75100: '',
        p75110: ''
      },
      alipayInfoObject: {
        p74010: '',
        p74030: '',
        p74020: '',
        p74040: '',
        p74060: '',
        p74004: '',
        p74001: '',
        p74002: '',
        p74003: '',
        p74005: ''
      },
      aliSRObject: {
        p74101: '',
        p74102: '',
        p74103: '',
        p74104: '',
        p74105: '',
        p74106: '',
        p74107: '',
        p74108: '',
        p74109: ''
      },
      saobeiInfoObject: {
        p79181: '',
        p79182: '',
        p79183: '',
        p79184: '',
        p79185: ''
      },
      wechatComInfoObject: {
        p73010: '',
        p73020: '',
        p73030: '',
        p73040: '',
        p73080: '',
        p73090: '',
        p73070: '',
        p73050: '',
        p73091: ''
      },
      wechatSerInfoObject: {
        p72010: '',
        p72020: '',
        p72030: '',
        p72040: '',
        p72050: '',
        p72060: '',
        p72100: '',
        p72110: '',
        p72080: '',
        p72070: '',
        p72120: '',
        p72121: '',
        p72130: '',
        p72140: '',
        p72150: '',
        p72160: '',
        p72170: '',
        p72122: '',
        p72180: '',
        p72181: '',
        p72182: '',
        p72183: '',
        p72190: '',
        p72191: '',
        p72192: ''
      },
      unionPayInfoObject: {
        p71010: '',
        p71020: '',
        p71030: '',
        p71040: '',
        p71050: '',
        p71060: '',
        p71110: '',
        p71120: '',
        p71130: '',
        p71140: '',
        p71150: '',
        p71160: '',
        p71210: '',
        p71190: '',
        p71221: '',
        p71991: '',
        p71992: '',
        p71990: '',
        p71993: '',
        p71994: '',
        p71310: '',
        p71320: '',
        p71330: '',
        p71340: '',
        p71341: '',
        p71350: '',
        p71401: '',
        p71402: '',
        p71403: '',
        p71404: '',
        p71405: '',
        p71406: '',
        p71407: '',
        p71408: '',
        p71409: '',
        p71421: '',
        p71422: '',
        p71423: '',
        p71424: '',
        p71425: '',
        p71426: ''
      },
      CQETCInfoObject: {
        p78110: '',
        p78120: '',
        p78130: '',
        p78140: '',
        p78141: '',
        p78150: ''
      },
      QTETCInfoObject: {
        p78210: '',
        p78220: '',
        p78230: '',
        p78240: ''
      },
      SZSFETCInfoObject: {
        p78901: '',
        p78902: '',
        p78903: '',
        p78904: ''
      },
      SHETCInfoObject: {
        p78610: '',
        p78620: '',
        p78630: '',
        p78640: '',
        p78650: 'https://parking.sptcc.com:8443/etc/etcparking',
        p78660: 'ETC_PARK_DIRECT',
        p78670: 'GNDUFjWGE5hUF04j9Dw',
        p78680: '',
        p78690: ''
      },
      MYZXETCInfoObject: {
        p78710: '',
        p78720: '',
        p78730: ''
      },
      TeslaInfoObject: {
        p79601: '',
        p79602: '',
        p79603: '',
        p79604: 'http://redpay.shangjieiot.com/ThirdAPI/api/Coupon/TeslaCoupon/api/suc-coupon',
        p79605: '',
        p79606: ''
      },
      CubeInfoObject: {
        p79651: '',
        p79652: ''
      },
      SamsClubInfoObject: {
        p94301: '',
        p94302: '',
        p94303: ''
      },
      HTETCInfoObject: {
        p78801: '',
        p78802: '',
        p78803: '',
        p78804: ''
      },
      YunZongInfoObject: {
        p78410: '',
        p78420: '',
        p78430: '',
        p78440: '',
        p78450: '',
        p78460: '',
        p78470: '',
        p78480: '',
        p78490: ''
      },
      YunZongADInfoObject: {
        p78510: '',
        p78520: '',
        p78530: '',
        p78540: '',
        p78590: ''
      },
      AppletInfoObject: {
        p73110: '',
        p73130: '',
        p73115: '',
        p73150: '',
        p73151: '',
        p73152: '',
        p73153: '',
        p73165: ''
      },
      GRGInfoObject: {
        p79201: '',
        p79202: '',
        p79203: '',
        p79204: '',
        p79205: ''
      },
      AHZFYInfoObject: {
        p79702: '',
        p79703: '',
        p79704: '',
        p79705: '',
        p79710: '',
        p79711: '',
        p79712: '',
        p79709: '0'
      },
      chinaUnionPayInfoObject: {
        p79801: '',
        p79802: '',
        p79803: '',
        p79804: '',
        p79805: '',
        p79806: '',
        p79807: '',
        p79808: '',
        p79811: '',
        p79809: '0',
        p79810: '0'
      },
      PYunPayInfoObject: {
        p94171: '',
        p94172: '',
        p94173: '',
        p94174: '0',
        p94175: '0',
        p94176: ''
      },
      CSRCBPayInfoObject: {
        p79901: '',
        p79902: '',
        p79903: '',
        p79904: '',
        p79905: '',
        p79906: '',
        p79907: '',
        p79908: '',
        p79909: '',
        p79912: '0',
        p79910: '0',
        p79911: ''
      },
      AHSRCBPayInfoObject: {
        p79401: '',
        p79402: '',
        p79403: 'https://epos.ahrcu.com:3443',
        p79404: '',
        p79405: '0',
        p79406: 'http://ansrcbpay.shangjieiot.com:19080'
      },
      AHSRCBPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      mobobInfoObject: {
        p79501: '',
        p79502: '',
        p78503: '',
        p79504: ''
      },
      BJHTInvObject: {
        p99901: '',
        p99902: '',
        p99903: '停车服务费',
        p99904: '',
        p99905: '',
        p99906: '30',
        p99907: 'http://36.112.132.68:9122/eisp',
        p99908: '0',
        p99909: '',
        p99910: '',
        p99911: '',
        p99912: '',
        p99913: '',
        p99914: '',
        p99915: ''
      },
      parkTypeList: [{
        value: '0',
        label: '商场'
      }, {
        value: '1',
        label: '写字楼'
      }, {
        value: '2',
        label: '住宅小区'
      }, {
        value: '3',
        label: '医院'
      }, {
        value: '4',
        label: '酒店宾馆'
      }, {
        value: '5',
        label: '风景区'
      }, {
        value: '6',
        label: '游乐场'
      }, {
        value: '7',
        label: '学校'
      }, {
        value: '8',
        label: '交通枢纽'
      }, {
        value: '9',
        label: '机关事业单位'
      }, {
        value: '10',
        label: '剧院'
      }, {
        value: '11',
        label: '道边车场'
      }, {
        value: '12',
        label: '办公园区'
      }, {
        value: '13',
        label: '物流园'
      }],
      CCBCallbackUrl: '',
      UnionPayCallbackUrl: '',
      UnionPayQueryPreAmountUrl: '',
      UnionPayQueryParkInfoUrl: '',
      isEdit: false,
      curRowInfo: {},
      tab_height: 0,
      editOrDetail: 'editBaseInfo',
      parkEditOrDetailVisible: false,
      detailTitle: '查看停车场信息',
      parkDetailVisible: false,
      choiceCusts: [],
      bindQueryfParkNo: '',
      bindQueryInput: '',
      selCustID: '',
      parkList: [],
      synParkList: [],
      tableHeight: 0,
      pageSize: 20,
      pageIndex: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getParkByCurrUser', 'getParkPayParams', 'getCustByGroup', 'getAllParkParamByParkId', 'getMapAndParkType', 'getRateGroupByCustId', 'saveParkPay',
      'deletePark', 'synParkById', 'getCurrentUserPers', 'getPayUrl'
    ]),
    changeAliParkID (obj, type) {
      setTimeout(() => {
        if (type === 1) {
          this.aliSRObject.p74107 = obj
        } else {
          this.alipayInfoObject.p74003 = obj
        }
      }, 200)
    },
    changeAliParkToken (obj, type) {
      setTimeout(() => {
        if (type === 1) {
          this.aliSRObject.p74105 = obj
        } else {
          this.alipayInfoObject.p74002 = obj
        }
      }, 200)
    },
    initAd () {
      if ((this.BSTInfoObject.p78551 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写流量主账号',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTInfoObject.p78552 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写账号密钥',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTInfoObject.p78554 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请选择停车场类型',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTInfoObject.p78555 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写场库详细地址',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTInfoObject.p78557 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写api请求地址',
          type: 'warning'
        })
        return false
      }
      if (this.BSTInfoObject.p78553.length > 20) {
        this.BSTInfoObject.p78553 = this.BSTInfoObject.p78553.substring(0, 20)
      }
      var fParkName = this.curRowInfo.fParkName
      if (this.curRowInfo.fParkName.length > 20) {
        fParkName = this.curRowInfo.fParkName.substring(0, 20)
      }
      this.init_loading = true
      park.initBST({ 'accountId': this.BSTInfoObject.p78551, 'secret': this.BSTInfoObject.p78552, 'name': fParkName, 'parkNumber': this.BSTInfoObject.p78553, 'parkType': this.BSTInfoObject.p78554, 'address': this.BSTInfoObject.p78555, 'url': 'http://init.ad.parking520.com' }).then(res => {
        if (res && res.data) {
          this.init_loading = false
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.BSTInfoObject.p78556 = data.Data
              this.$message({
                type: 'success',
                message: data.Msg
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    initTwoAd () {
      if ((this.BSTTwoInfoObject.p78571 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写流量主账号',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTTwoInfoObject.p78572 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写账号密钥',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTTwoInfoObject.p78574 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请选择停车场类型',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTTwoInfoObject.p78575 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写场库详细地址',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTTwoInfoObject.p78577 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写api请求地址',
          type: 'warning'
        })
        return false
      }
      if ((this.BSTTwoInfoObject.p78579 || '').trim().length <= 0) {
        this.$message({
          message: '提示：请填写accessKeyId',
          type: 'warning'
        })
        return false
      }
      if (this.BSTTwoInfoObject.p78573.length > 20) {
        this.BSTTwoInfoObject.p78573 = this.BSTTwoInfoObject.p78573.substring(0, 20)
      }
      var fParkName = this.curRowInfo.fParkName
      if (this.curRowInfo.fParkName.length > 20) {
        fParkName = this.curRowInfo.fParkName.substring(0, 20)
      }
      this.inittwo_loading = true
      park.initBSTTwo({ 'accountId': this.BSTTwoInfoObject.p78571, 'secret': this.BSTTwoInfoObject.p78572, 'name': fParkName, 'parkNumber': this.BSTTwoInfoObject.p78573, 'parkType': this.BSTTwoInfoObject.p78574, 'address': this.BSTTwoInfoObject.p78575, 'url': this.BSTTwoInfoObject.p78577, 'accessKeyId': this.BSTTwoInfoObject.p78579 }).then(res => {
        if (res && res.data) {
          this.inittwo_loading = false
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.BSTTwoInfoObject.p78576 = data.Data
              this.$message({
                type: 'success',
                message: data.Msg
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    copy (obj, className) {
      var clipboard = new Clipboard('.' + className)
      clipboard.on('success', e => {
        this.$message({
          message: '提示：复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          message: '提示：该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    tabClick () {
      this.pageIndex = 1
      this.total = 0
      this.initData()
    },
    changeInvoiceEnable (val, type) {
      if (val) {
        switch (type) {
          case 0:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.HTInvoiceObject.p99808 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 1: // 容津
            this.EInvoiceObject.p99299 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.HTInvoiceObject.p99808 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 2:
            this.RJInvoiceObject.p99160 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.HTInvoiceObject.p99808 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 3:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.HTInvoiceObject.p99808 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 4:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HTInvoiceObject.p99808 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 5:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 6:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.HTInvoiceObject.p99808 = '0'
            this.BJHTInvObject.p99908 = '0'
            break
          case 7:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            this.unionEInvoiceObject.p99507 = '0'
            this.gdEInvoiceObject.p99607 = '0'
            this.HXInvoiceObject.p99701 = '0'
            this.TJHTInvObject.p99861 = '0'
            this.HTInvoiceObject.p99808 = '0'
            break
        }
      }
    },
    changeEnable (val, type, typeName) {
      if (val === '1') {
        switch (type) {
          case 1: // 银联
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            if (typeName === 'b2c') {
              this.unionPayInfoObject.p71030 = '46938143680ffdf301682b1cd4a70006'
              this.unionPayInfoObject.p71040 = '67440d9cb2984c31874b2acb2d6556fa'
              this.unionPayInfoObject.p71050 = 'https://qr.chinaums.com/netpay-route-server/api/'
            } else if (typeName === 'dcep') {
              this.unionPayInfoObject.p71407 = 'https://api-mop.chinaums.com/v1/netpay/dcep/'
            } else if (typeName === 'dcepB2C') {
              this.unionPayInfoObject.p71425 = 'https://api-mop.chinaums.com/v4/poslink/transaction/'
            } else {
              this.unionPayInfoObject.p71130 = 'QRPAYDEFAULT'
              this.unionPayInfoObject.p71140 = 'WWW.SHRUANJIE.COM'
              this.unionPayInfoObject.p71150 = '5135'
              this.unionPayInfoObject.p71160 = 'mTejiB5hacQrTTz5dzsE5ziDHRWFsDG47kDssyswDWfB5dX8'
              this.unionPayInfoObject.p71210 = 'https://qr.chinaums.com/netpay-route-server/api/'
            }

            break
          case 2: // 微信服务商
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 3: // 微信普通商户
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 4: // 支付宝
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 5: // 交行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 6: // 工行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 7: // 广发支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 14: // 新版广发支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 8:
            if ((this.AppletInfoObject.p73110 || '').trim().length <= 0) {
              this.AppletInfoObject.p73110 = '20191223'
            }
            if ((this.AppletInfoObject.p73130 || '').trim().length <= 0) {
              this.AppletInfoObject.p73130 = '83d96c2aec5deaa8e2d675d9121cef4e11'
            }
            if ((this.AppletInfoObject.p73150 || '').trim().length <= 0) {
              this.AppletInfoObject.p73150 = 'https://fpj.datarj.com/einv/kptService/rj/rjxx'
            }
            if ((this.AppletInfoObject.p73151 || '').trim().length <= 0) {
              this.AppletInfoObject.p73151 = 'https://wxpap.shangjieiot.com/api.php'
            }
            break
          case 9: // 建行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 10: // 云纵支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 11: // 浦发支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 13: // 农行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 12:
            if ((this.HTETCInfoObject.p78803 || '').trim().length <= 0) {
              this.HTETCInfoObject.p78803 = this.pay_url + '/HtmlPay/CTB/HTETCLiquidationNotity'
            }
            break
          case 15: // 扫呗支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 16: // 广电运通支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 17: // 农商
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            break
          case 18: // 智付云
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 19: // 中国银联
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 20: // 常熟农商行
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.PYunPayInfoObject.p94174 = '0'
            this.PYunPayInfoObject.p94175 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 21: // PYun支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.wechatSerInfoObject.p72190 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CGBNewInfoObject.p77509 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.SPDInfoObject.p79100 = '0'
            this.SPDInfoObject.p79109 = '0'
            this.YunZongInfoObject.p78490 = '0'
            this.ABCInfoObject.p79150 = '0'
            this.ABCInfoObject.p79158 = '0'
            this.saobeiInfoObject.p79185 = '0'
            this.GRGInfoObject.p79205 = '0'
            this.AHZFYInfoObject.p79709 = '0'
            this.CSRCBPayInfoObject.p79911 = '0'
            this.chinaUnionPayInfoObject.p79809 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.chinaUnionPayInfoObject.p79810 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
        }
      }
    },
    setHXDefault (result) {
      if (this.HXInvoiceObject.p99712 === '1') {
        this.HXInvoiceObject.p99701 = '1'
        this.HXInvoiceObject.p99702 = '91120101673736899J'
        this.HXInvoiceObject.p99703 = '天津粤海天河城购物中心有限公司'
        this.HXInvoiceObject.p99704 = '天津市和平区小白楼街和平路263号'
        this.HXInvoiceObject.p99705 = '022-58866188'
        this.HXInvoiceObject.p99706 = '0302010509300337321'
        this.HXInvoiceObject.p99707 = '3040502020199000000'
        this.HXInvoiceObject.p99708 = '王磊'
        this.HXInvoiceObject.p99709 = '孟亚楠'
        this.HXInvoiceObject.p99710 = '吕博'
        this.HXInvoiceObject.p99711 = '0.09'
        // this.HXInvoiceObject.p99712 = '1'
        this.HXInvoiceObject.p99713 = '30'
        this.HXInvoiceObject.p99714 = '天津粤海天河城购物中心有限公司'
      } else {
        this.HXInvoiceObject.p99701 = '0'
        this.HXInvoiceObject.p99702 = ''
        this.HXInvoiceObject.p99703 = ''
        this.HXInvoiceObject.p99704 = ''
        this.HXInvoiceObject.p99705 = ''
        this.HXInvoiceObject.p99706 = ''
        this.HXInvoiceObject.p99707 = ''
        this.HXInvoiceObject.p99708 = ''
        this.HXInvoiceObject.p99709 = ''
        this.HXInvoiceObject.p99710 = ''
        this.HXInvoiceObject.p99711 = ''
        // this.HXInvoiceObject.p99712 = '0'
        this.HXInvoiceObject.p99713 = ''
        this.HXInvoiceObject.p99714 = ''
      }
    },
    setParams (result, type) {
      switch (type) {
        case 0:
          if (result) {
            this.unionEInvoiceObject.p99505 = ''
            this.unionEInvoiceObject.p99504 = ''
          } else {
            this.unionEInvoiceObject.p99502 = ''
            this.unionEInvoiceObject.p99501 = ''
          }
          break
        case 1:
          if (result) {
            // 上传数据地址
            this.RJInvoiceObject.p99140 = 'http://open2.datarj.com/webService/kptService'
            // 开票链接
            this.RJInvoiceObject.p99150 = 'https://fpj.datarj.com/einv/kptService/rj/rjxx'
            // 版本3.0
            this.RJInvoiceObject.p99153 = '1'
          } else {
            // 上传数据地址
            this.RJInvoiceObject.p99140 = ''
            // 开票链接
            this.RJInvoiceObject.p99150 = ''
            // 版本
            this.RJInvoiceObject.p99153 = ''
          }
          break
        case 2:
          if (result === 0) {
            // 公众账号ID
            this.wechatSerInfoObject.p72010 = 'wx2ec887417aa7ba68'
            // 商户号
            this.wechatSerInfoObject.p72020 = '1543527411'
            // AppKey
            this.wechatSerInfoObject.p72050 = 'RUANjie1122334455Sh1122334455jie'
            // 密钥
            this.wechatSerInfoObject.p72060 = '04bec2e9a8b9229d7e936a336583c012'
            // 进场通知
            this.wechatSerInfoObject.p72100 = 'BF5wu72eJwW6ZmlbR9-y66m_PlBTnoBbHDHwJ56iSpQ'
            // 出场通知
            this.wechatSerInfoObject.p72110 = 'IDTUs0njchqwFh9GdmE-r9xWqhkmGhppUQcH-r9FQpM'
            this.wechatSerInfoObject.p72122 = '商秸参数'
          } else if (result === 1) {
            // 公众账号ID
            this.wechatSerInfoObject.p72010 = 'wxb44cff5c6cb4537d'
            // 商户号
            this.wechatSerInfoObject.p72020 = '1603236707'
            // AppKey
            this.wechatSerInfoObject.p72050 = 'RUANjie1122334455Sh1122334455jie'
            // 密钥
            this.wechatSerInfoObject.p72060 = 'ae4461b278f14aa6983b9fe9e4d8254c'
            // 进场通知
            this.wechatSerInfoObject.p72100 = 'BF5wu72eJwW6ZmlbR9-y66m_PlBTnoBbHDHwJ56iSpQ'
            // 出场通知
            this.wechatSerInfoObject.p72110 = 'IDTUs0njchqwFh9GdmE-r9xWqhkmGhppUQcH-r9FQpM'
            this.wechatSerInfoObject.p72122 = 'HT参数'
          } else if (result === -1) {
            // 公众账号ID
            this.wechatSerInfoObject.p72010 = ''
            // 商户号
            this.wechatSerInfoObject.p72020 = ''
            // AppKey
            this.wechatSerInfoObject.p72050 = ''
            // 密钥
            this.wechatSerInfoObject.p72060 = ''
            // 进场通知
            this.wechatSerInfoObject.p72100 = ''
            // 出场通知
            this.wechatSerInfoObject.p72110 = ''
            this.wechatSerInfoObject.p72122 = '无参数'
          }
          break
        case 3:
          if (result === 0) {
            // 支付宝AppID
            this.alipayInfoObject.p74010 = '2019080666158161'
            // 商户私钥
            this.alipayInfoObject.p74030 = 'MIIEogIBAAKCAQEAh8SOFObquBPEKgw8Sgpar5578/g7K3A6sirBUyhpLDfxSFCEj4eEdftekP5y2rX6rsMFvhCQk6MiGJhMId7YIdclTrlGFOsIVELwZdgQ0P8KQGKmNGj2cnEVYYr5cWUR8Nr/0mSxupzEbm4yFi1rVkhH1GTBC9a9XIIGbQgWMIPOkWAiq/DFLGW/m5x5FPr/xLEZo6S3GtSUiE0SUfS6uSVd8wuvYoyZwIzuizT+8TiVEPafbypvUPVpV4QW09q00U6DovjpBwwTCt1eOjOL7ujCWlqlpqgXkvCr8RfYBE2b0Xbw+El/Omd+8xM1cBlyii2o5jBQYygggz2+zBhepwIDAQABAoIBAEspm+cid+t0tfL5Vx8+YDo9qS3FzSwdM8GTPfgFtUQPrHp2aQz033ZZtV7cH0XJ3YCG41T34rJ5a9Tl67AMqOcDLtpIY+4MuE29yUz4s0ahC1Hdy1nUiiuNQ2L/B12psKcA9wPJT0OaqnzgcMYqWvQni+yf4ufk+GyQZ3JROcedPIXSxPAnBOIwkK8RL/FE2eJrqk4Ma7iDgqlXB7KyWeSXFbmziAhhh8ergecf5cBMCJDlM5uulQd3OD1/2Eae+dy9ERZpdtL5SRaHvDDft4AjXaX3/6LY7bBvbcAh9JDIdJKRRD5o/82BoD1oy7x5mHzheVJZGasDtt/5GyWFJ8ECgYEA7QaecLY5aeGm8SVwNiFT59dVK7KyRbthzKlRtxRofG06I6hTSCMBJHgD66+h1Wl95gCqQgUjvgeqYYyRcMBoedeFT/cEIUrx6T8RPxOzIlQcsTAvD4JVKU5u+1IrA8uhLgRAz+vVlbpHVnMEdbdIfCyMuyyLtryPzmnfTMC0vjcCgYEAkqLZqmAXI670zkRCwzWpW3iIG6ak2CfeLSw7O4/Gt847u4ygitan3SMICI3rcFAhd5zA5UZzAj6jE0ZMJYeFIvlJFUdg2lS0hDJiKoUmON0sIHPOuGYqQdAws6Ey/MJPyk+BdzPmeB+phemI/YWqh4sYw3neiurX7D5Byna/qxECgYBGPyLv5qGnZrASYfUapc/3MxNT6xb4oas/e6LzLoI09i436SgdhfpNs5/91sSQuj4Mz3+mJ13LcPwnAwELuIp+KcihxWSc9Vgyt3VGC3GYp/ME9HHOF+NjZZJwu45yBoSTXcFTneJkCJwh296jgJlj69QdmPsjQkkgdLIwTiCDCwKBgCWZtqDWlPhkc4e0vz3ZM70t0hDtEVYQGwuQTPv/6R/WtUBpVf1j/5VX10aCRb39/ibyvg/Mmc8Yiq51ly8EaiJGs/PN4sr5b3R6iuuGSv/HzvnfWEG2iN1paiOVkUJ4/QbOjk8nstBYphqdgLApp0msZEQzqtoKUCXW7P3ip1FRAoGALlf7vTQuLKIoibtzqOe2LUCwKbNx2qSIAwTPFzzo9vdaLC/29ruvtk2mNtoYJjKTf0VojOIaw9Rrort1Xrim/LaPF7sk/3Q12JFlqlER5Wla4GJ9Ec1XfKSK3CNAZJznL2w2u4T7YqLbXXwIVh9wQlXMz25tvYSmo9ryxRDtblM='
            // 支付宝公钥
            this.alipayInfoObject.p74020 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiBoXDptcd7R9oZ6OLJv89+gVPCRrnTJ5ImihRh0AxVgROmgCkV2obN2kvnr8DYQJcUApm9IIBqCfkWMjiTf0vPkOJ8qYLF9B+iaAnwUeIGdpsZBJS7TgfW+U0era0K3dLlLhorjBhu9SonmIoYXQ2l4IF+sXHduzUkgI572dNL/D5/CENZeFLfJ1EkpEBuFjj7XX2Wa7K3UNfdTKynO+ELfdwqw7stUTSmHScWtGbGT0tvIvL1G5XZtO4DFsBPHG+p+s/ytfDt2aDvF9qaC0+/rmF13AYJdzAGkcIfVHqYOktnUATJp/6KSSRknRbUxovXil14aAcnuxHdWkcILHpQIDAQAB'
            // 服务商PID
            this.alipayInfoObject.p74001 = '2088531665011033'
            // 支付链接
            this.alipayInfoObject.p74040 = 'https://openapi.alipay.com/gateway.do'
            this.alipayInfoObject.p74005 = '商秸参数'

            this.aliSRObject.p74104 = '2088531665011033'
            this.aliSRObject.p74106 = 'https://openapi.alipay.com/gateway.do'
            if ((this.alipayInfoObject.p74002 || '').trim().length > 0) {
              this.aliSRObject.p74105 = this.alipayInfoObject.p74002
            }
            if ((this.alipayInfoObject.p74003 || '').trim().length > 0) {
              this.aliSRObject.p74107 = this.alipayInfoObject.p74003
            }
          } else if (result === 1) {
            // 支付宝AppID
            this.alipayInfoObject.p74010 = '2021002112673494'
            // 商户私钥
            this.alipayInfoObject.p74030 = 'MIIEpQIBAAKCAQEAyN95nTTF79amXe/paqnMSarm47l64O6cYNNWLxtXAOMRzXIntAhXWzHp7086Uk2guAxcLpjeyWny1e0nYGzHlCmM5ead44lFpImUvVXu4NEeGkiIjRqFIE3YuVQLBzHuEg4PfUTuGK0q9xX+kXsrHuqNZlZcC07RRiAD4lu35N/me015qRtGQnpYIZX7MZDV0qNvLziSFgF5ZsWAKi7u4JTcOKxy4tM7lVEFnn4ndAcdIm+Xv4bwKFAUx4y+FROe8Sz6muB21wPDH5EStuhTiWxRqliNhWoiu84EcQfoTdGn39twn3g2Px3Cun3a6LbSnGFpI5j30BDGBr2KUmCaQwIDAQABAoIBAQC46QdBkPf43WaOqK/9UUtOMTWUQgT8lIp9k24NtSQ1G9IihkhIMTmBKISJmCw+4Vjms/ITrwO+83noNgR+fgSGvm0GoXGMqKvkWAYE+NsKN1Z3qXeSNOyBnUe46sWwHOVj12+oyFBJhPc9NxD9iR1bu1zo7OyUODzrScNplzbERzo7RW+XRMEJp9fBNqum+2g+KFOu9YE+90im/RHMn/UVw3vyQW6md8bfo/wHdSfdY4U91zTGPdbjxDgtq9667iA4Ep9oe5zJ1QGImClbto21At0afgY+CiKXl0eCEglgVK3QYKT3bwxRkC3BDKtm7HORlOVCg2CON1bwFLNg/21pAoGBAOySK3kKlPVhia8WeHhiUtV47J2AZSY4ojCdUK6Npa0/ipt1iJVuIV2Cg+19UzsmgDsHUo8vM+BmY4qADw3pnauLn3uPOe66pqjjOcNtMkuM+J/9E+CcrbhSoFHbH9cEAYYs2CXhnud58+gv9OgVLTvd6w8JSXgA4TjmR/qwNgfPAoGBANlew/cNN2z0m9ZYgBXwKYe/FQ+3SDuV6T9QhDKhLNuK5UTMgPCu380CS4CUNaypixk2oUSThXj6fxt9I9qMqAoJ4zK6P9LEa4y5a7dnjQ80vPogiiZEDE/bWQJx4comgw7kbN/vVu0TeBRSkjsupv9snANG4FJpMjPnPzwxSu9NAoGBAN2prEAzERXGubqrxF+QSWsqbhK5/ozMnfQNQ076/BUUJ6y4eS0CzxKOO01ok3cmARrOJqZxJRuK9JQOn4x6rDjTj7C3qCGvFH/EwRgDFhBCW6eU+24HgKLoEL4CIphWcZMmK7V67WiZFVgmr0RSq1qf+iLRodxmfqHQ6/rR5x5zAoGAa5NcxH2D+qYsIa525WSQCSBmGfsJAoQ0hSMh6bSecKCSyrOy9Gp3VAxYtW+kCKl3r6i7syaXHcJK+Z27CsQlvaIbENXgFD0lROXXC1NyGh5tkBReioWO2k6iBHW72sGohsxBnanjiTzjZptex29VMn/bzjtbdS2erNU7FF0IytkCgYEAoSMGBLDy5DJCOiBJiFu+pRAl0397KVKANOYIjTZKYNVmuKMyiq9IDREb6EgmQwZD7GlOlW53nJI8tLU6Iu696WWZsx/vWn8mHK91wGANeyXkWgVGyvSE0Mgiy6HFlMjmJoPiYtZdGM6F/4daNfw445adC206i3L3KrpKe6qfwT0='
            // 支付宝公钥
            this.alipayInfoObject.p74020 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAld82xKxJDGEXGYedXgOO6kJrQRgKYpjwkqMXRNVdZzYfz/+jmyilg7icOqtx5SNQ51w+4nxLOP71KtQZe98CFj7RCuq8q0H9pd5G0m3AzMxr6Z7fQgL9qAwzZaFStcmINKd0Y3gxdMUyixHNSfAKFyg2ZDO2ExrdEcKHpx2TsraLbAx7v2ttIdHF96epCI5FkWUJzEpNaGDlzeWLXroaCOX1xYZXZyOCXFWEadTVCF7HjoqyDDaKmd3Xf0o7oBhprkyldwbD/LWbIEwSqjNnsX9CzIhoBVhqnRIjV62qIs53MYE/z+yY02jrFyr26CGzajuci4Y5wK7jXWKnCc6RkQIDAQAB'
            // 服务商PID
            this.alipayInfoObject.p74001 = '2088931633026173'
            // 支付链接
            this.alipayInfoObject.p74040 = 'https://openapi.alipay.com/gateway.do'
            this.alipayInfoObject.p74005 = 'HT参数'

            this.aliSRObject.p74104 = '2088931633026173'
            this.aliSRObject.p74106 = 'https://openapi.alipay.com/gateway.do'
            if ((this.alipayInfoObject.p74002 || '').trim().length > 0) {
              this.aliSRObject.p74105 = this.alipayInfoObject.p74002
            }
            if ((this.alipayInfoObject.p74003 || '').trim().length > 0) {
              this.aliSRObject.p74107 = this.alipayInfoObject.p74003
            }
          } else if (result === -1) {
            // 支付宝AppID
            this.alipayInfoObject.p74010 = ''
            // 商户私钥
            this.alipayInfoObject.p74030 = ''
            // 支付宝公钥
            this.alipayInfoObject.p74020 = ''
            // 服务商PID
            this.alipayInfoObject.p74001 = ''
            // 支付链接
            this.alipayInfoObject.p74040 = ''
            this.alipayInfoObject.p74005 = '无参数'
          }
          break
        case 4:
          if (result) {
            // APPKey
            this.gdEInvoiceObject.p99602 = '7c2e443dd1a22effefbb'
            // AppSecret
            this.gdEInvoiceObject.p99603 = '6828a94c1755ee99dd7a5377d79294d9'
            // 版本号
            this.gdEInvoiceObject.p99601 = '1.0.0'
            // 开票链接
            this.gdEInvoiceObject.p99604 = 'https://openapi.wetax.com.cn'
            // 门店编码
            this.gdEInvoiceObject.p99605 = ''
            // 商品税率
            this.gdEInvoiceObject.p99608 = '5'
            // 税收商品编码
            this.gdEInvoiceObject.p99609 = '3040502020200000000'
            this.gdEInvoiceObject.p99610 = 'http://einvapi.shangjieiot.com:8081/EInv/Invoice/QueryByCode'
          } else {
            // APPKey
            this.gdEInvoiceObject.p99602 = ''
            // AppSecret
            this.gdEInvoiceObject.p99603 = ''
            // 版本号
            this.gdEInvoiceObject.p99601 = ''
            // 开票链接
            this.gdEInvoiceObject.p99604 = ''
            // 门店编码
            this.gdEInvoiceObject.p99605 = ''
            // 商品税率
            this.gdEInvoiceObject.p99608 = ''
            // 税收商品编码
            this.gdEInvoiceObject.p99609 = ''
            this.gdEInvoiceObject.p99610 = 'http://einvapi.shangjieiot.com:8081/EInv/Invoice/QueryByCode'
          }
          break
        case 5:
          if (result) {
            this.YunZongInfoObject.p78460 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2dRJA7LwRZ3HVRXfefAn+Ks317uyf5oRMXSqNmmgJV5q4g5DD4HX0DBp/7i2W9oT3LvC1gvMQeRXeRx6DwzRNCpuVZ/xRiPgyrSopJgCRkCaZd7wQYJGVc359qXakD6bPms/3tKnYPnt/6R1AH2N6yorgcKRQxvHzilHvHSkZGbhoTRld7cuv0zEDo28PR7y1aDGcz+OO7a6ASttguLsVpZM97lY108+uPmuSB282v6C4G45nNjCkPH4kz8XxpnAiW+ONQYUd/hdJ8SpfyPO07FtwwqJNHeQM2sB9z9Of85lkE5AQ8GHjI9c4kcgQuSbxAI0By13anFKxxwHYv7LBQIDAQAB'
            this.YunZongInfoObject.p78470 = 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCH5b4ZyUXcABqgCNxl47SNtHDN/FgFSjymzXjHa94LON4NCNWM4zYsWX1umnuERUff22liFuW3/tctanEIopUX9vMvdm3IrFv8Yb3R4mQVTzOQwkEce6dynZ/sIotJPjRljtIIi1MSFR5slCCUKvaHnhR3q6xBi44rMXU6cohi5b09F0MUnC8nx85I+uMTTGUs/Jxi804Cu4y4nTVqZtqijMqbjThOtITP0UFFy2MgqULcmPOR6p52fbIOvC5Sq3WQsosDoL6w6sx+C0XqPz05jc9+hWK71VlwPZC8g8xXR15VaPR5zrHX7Mx6nyT7DQDydrG3/ix4JDKLH/0Z5OU9AgMBAAECggEAdRNL7tMjSCEezvhTR8Qf7GSjOhJHkmceUWV6w/L93BUl13zg3Ptx1EtUcFDOUGmPPh+8bjDjvtvhbNLihlnqsDaj0yPn+JXkuU1LRuIO7vzIo9F2Xp945pk9CSXJcVQRt9yOvaWp704aY9hJKNzKfpOFdoODZwRfen6lS7EYJnoYWuYbJnt10IBAFR01e2YmGsTxVldl1VJV5iMcCd7GEje9Z2XOiCi8OTvK4WM1fzHfhaBve+eWoBnE+5M5xjHNt7nlrQYrTd4nEA4upm58iARn2z52xPt+GhG+c6zoDbJafoUcADF4TKIOt8+FNHLoF/rqHQtYtynNFEktdkMlgQKBgQDamQZXtOjUS0U0c/03riKJWhJEnOfkE0q2KxyBMHJ1NtCoVWYWfkvtEv+0C42QDLA+1mbw/hsgQq+K9aD+dMW3jtL2xyNp+bwtm2hvPr0fjUDW4GOYxV6Ra/0/NZi78kG/aQQ3y+4I+FABmXWThqHws5Yalx4UU5fPpZXCRVP1NQKBgQCfJkt5QTy4oOKmgN3rH/k6L2YgJshX53W4bOyyygUnn96q/h4Jbe3uqHNwjEhZULKGKFQxWbkHOg+H3p1B7K5HzaQsxWeMFjrpwwlH28h5Fsb1m8zKgmWS3m/Vl6AD9Yrsx8udg69TVMPcqcfhDpkcM+i5aDNVfOrSvIXHQ/7Y6QKBgHMN49a582n5jB1Fh1uNHcRpUgAnDa5vsP0cx83/b97d0QkomajxJIlNXKSpCANvijwooNnrBN//+WEMU4Zac85fMA6PVcZrmW3vxBH5VZWLxTrTs9gu2c10p0Bjt1YE9jIG1h+ACHNULtgIq2fQjt+fxjuMmlpcfSTfpGkyEDSZAoGAJB9SBByNhq5lozseo45nSBCYEnYbBPCxJIH8m3wE/YBoztDMyoEb/w5W3VXJ2hPZ4V9n9KeTupMwETuy39Kzn/KJ7+uCXCZzirlM8vVspCdKU1bgfZppKZO5OHaoyB1EQgf7LC5GbhiQOBaFGozwrZkOmn6PIDkxJ1HI33iMcHkCgYEAtCA284vZAsWBGnQY+l+zk71DMohIVMCrpmbBP3XEqN0JXE+OXW26AEMfD4ulfhIHNlZtLWHOFlPBd7Dj4fTJ3/UTmNj4Usofcu2gC7fxyA70uzo3dQEAL3PV5YZFNJUWnte5oavgD40D6x2vUHMv7hgL5GP7auicsSfhA1CLoGE='
            this.YunZongInfoObject.p78480 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAh+W+GclF3AAaoAjcZeO0jbRwzfxYBUo8ps14x2veCzjeDQjVjOM2LFl9bpp7hEVH39tpYhblt/7XLWpxCKKVF/bzL3ZtyKxb/GG90eJkFU8zkMJBHHuncp2f7CKLST40ZY7SCItTEhUebJQglCr2h54Ud6usQYuOKzF1OnKIYuW9PRdDFJwvJ8fOSPrjE0xlLPycYvNOAruMuJ01ambaoozKm404TrSEz9FBRctjIKlC3Jjzkeqedn2yDrwuUqt1kLKLA6C+sOrMfgtF6j89OY3PfoViu9VZcD2QvIPMV0deVWj0ec6x1+zMep8k+w0A8naxt/4seCQyix/9GeTlPQIDAQAB'
          } else {
            this.YunZongInfoObject.p78460 = ''
            this.YunZongInfoObject.p78470 = ''
            this.YunZongInfoObject.p78480 = ''
          }
          break
        case 6:
          if (result) {
            this.SPDInfoObject.p79112 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA29bhth9d3nAj2iGs1wFoirFbUSfaLAhPQiq6FuuebI7HzhxcQvOfkvexbWqZrvuYmu84wKbdm5sOsPMJHewCdXFMsTZGd2WICGeD5hd/sQjHyu5973pKl7J/eYcRATrJaPDPoy6t5SyJ6zcd0nTWghT5tU6tnXYfvev5NaTnAZSAwtSyEZgLbBn/cRMDUbR1h3rG+r1RVT3P0TAeu1h3YH0w/R1WmdzW2M4diLQfdyuh1KNFtfN9EMLqyam6CIGJ17mi5eNY6JDYjZ0KdOVB92S+8XWvK0NTeUNCVRFp0JgusdBHkDzMNXu7lDdvJpxfPJjukO9UNO++bOatR4YOEQIDAQAB'
            this.SPDInfoObject.p79113 = 'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDb1uG2H13ecCPaIazXAWiKsVtRJ9osCE9CKroW655sjsfOHFxC85+S97Ftapmu+5ia7zjApt2bmw6w8wkd7AJ1cUyxNkZ3ZYgIZ4PmF3+xCMfK7n3vekqXsn95hxEBOslo8M+jLq3lLInrNx3SdNaCFPm1Tq2ddh+96/k1pOcBlIDC1LIRmAtsGf9xEwNRtHWHesb6vVFVPc/RMB67WHdgfTD9HVaZ3NbYzh2ItB93K6HUo0W1830QwurJqboIgYnXuaLl41jokNiNnQp05UH3ZL7xda8rQ1N5Q0JVEWnQmC6x0EeQPMw1e7uUN28mnF88mO6Q71Q0775s5q1Hhg4RAgMBAAECggEAEpjS7z0oC7Eg10sR+/46gcEPIIZmhmMNkWNb6qRz+mr5rA3qIB/L1/rsH31tEshl2HV0L5fuF0O+smlc1BMrAhRbkIIu49rK7ysSlVxXiPpdLGWQcbm+paaL8hPi9F+suhvk9MD2JPTnleZLt4n6u3ZayWOmfDOJ698Sbd9NS2zEbWphx0q2i9bJTdWFzcTXy7dyvE4eypbJPNtzQToydGy5GYZ6K1bwC56yMWbxL8iDSrBNNf3nHPJdwjSDWIyVJW2CGHzP84aXF8ielI+KI6LC0N9EZnzyxS+P7BiMailqYSIK9GoZ7FL9QT5GqTwnURe13M6+6vmlASjP8QVZoQKBgQD2R+auMEznCgtYOzb/1dghsTF5XrszyiBUW+q/Rzvfymqnly1hpOE7e/fUhEKIojYGSygnLLxhrwoDxPTMb8qyUTFiyloClBz6JP0MhLUbgy5DOfPRhdiOlgXnr7vhJYB6Hco5G78mmp/uWFBTMwIBvE/9uTnJtyTsdfw6CLARxwKBgQDkg9m8IzXQ9q69KVqNfZXiCI+P7fo2//XHY1KqmMz/0rF/Irl7tQYp1g+k/tmkjxAQH0t4YYt3O5ra/HmRArzb3ZcMe6IRPCOWFGnDs7EiPmwedUl45r11XcaJwt1z2zdDyn3s6P2J+NS1xA0ppGtsxiXlLq098cKxsk6CTnnhZwKBgA2FWQbLJA2zIXhQl+5nwRvobHzrVH+9YxT+jt69fG4G4OAejqFDuhHX9n02Xai+rxSdX7D25ci/IV+fmoj2wjwT9RAlZ9eoZgbdrP7Y8lB2XT3XmqkwHfmGBwD3RutPccRCim2kNlRaPNmLA63tqPiLbCDT4HZQlbhdqeFNxMzVAoGBALAMjGCPV9SnV7PP+j1rdV9wbPnbw5s/0uBLutJHahflAG4MGI4fxqHQkrjwxkgrF5r0ITabH9E6EHGJdTasv0c8DjTFwvQ4OspS67Cj7WGOacmFXpdQXMHg/yX/BJFPX+JQTHeKgFodY/KtGd7tFv30IhnQvhMtAGvaDPYC848dAoGBAIN9PvdZRFJVu59n+fAUYfothJUh6/eGNvDVbFdjM2abZGA/UN9tWjaB7ucJxZsbHqBeyTAJ2SoSBEGp3DjszVYuaDWeIFLNfN3sSx9bb6OkJHWKHmOoU6DFNpehRGVrZeOmvw/nFWIo8tK61JH3+O4RKUgnif8cNgDdtYhL9pXX'
          } else {
            this.SPDInfoObject.p79112 = ''
            this.SPDInfoObject.p79113 = ''
          }
          break
        case 18:
          if (result === '1') {
            // 上传数据地址
            this.RJInvoiceObject.p99140 = 'http://open2.datarj.com/webService/kptService'
          } else {
            // 上传数据地址
            this.RJInvoiceObject.p99140 = 'http://open2.datarj.com/webService/kptService'
          }
          break
        case 19:
          if (result === '1') {
            // 上传数据地址
            this.flagTemp = true
            this.HTInvoiceObject.p99802 = 'https://sdk.nuonuo.com/open/v1/services'
          } else {
            // 上传数据地址
            this.flagTemp = false
            this.HTInvoiceObject.p99802 = 'https://nnfp.jss.com.cn'
          }
          break
      }
    },
    submitForm (formName) {
      let param = {}
      param.curRowInfo = this.curRowInfo
      param.unionPayInfoObject = this.unionPayInfoObject
      param.wechatSerInfoObject = this.wechatSerInfoObject
      param.wechatComInfoObject = this.wechatComInfoObject
      param.alipayInfoObject = this.alipayInfoObject
      param.aliSRObject = this.aliSRObject
      param.BOCMWxInfoObject = this.BOCMWxInfoObject
      param.RJInvoiceObject = this.RJInvoiceObject
      param.EInvoiceObject = this.EInvoiceObject
      param.ICBCInfoObject = this.ICBCInfoObject
      param.CGBInfoObject = this.CGBInfoObject
      param.CGBNewInfoObject = this.CGBNewInfoObject
      param.SPDInfoObject = this.SPDInfoObject
      param.ABCInfoObject = this.ABCInfoObject
      param.CCBInfoObject = this.CCBInfoObject
      param.CQETCInfoObject = this.CQETCInfoObject
      param.QTETCInfoObject = this.QTETCInfoObject
      param.SZSFETCInfoObject = this.SZSFETCInfoObject
      param.SHETCInfoObject = this.SHETCInfoObject
      param.MYZXETCInfoObject = this.MYZXETCInfoObject
      param.HTETCInfoObject = this.HTETCInfoObject
      param.YunZongInfoObject = this.YunZongInfoObject
      param.YunZongADInfoObject = this.YunZongADInfoObject
      param.AppletInfoObject = this.AppletInfoObject
      param.nYCRMInfo = this.NYCRMInfo
      param.nBYSInfo = this.NBYSInfo
      param.JGDTInfo = this.JGDTInfo
      param.AHSRCBPayInfoObject = this.AHSRCBPayInfoObject
      param.FMInfo = this.FMInfo
      param.TeslaInfoObject = this.TeslaInfoObject
      param.CubeInfoObject = this.CubeInfoObject
      param.SamsClubInfoObject = this.SamsClubInfoObject
      param.unionEInvoiceObject = this.unionEInvoiceObject
      param.gdEInvoiceObject = this.gdEInvoiceObject
      param.SHJBHPayInfo = this.SHJBHPayInfo
      param.SHJBHPayInfo1 = this.SHJBHPayInfo1
      param.SHCardPayInfo = this.SHCardPayInfo
      param.saobeiInfoObject = this.saobeiInfoObject
      param.GRGInfoObject = this.GRGInfoObject
      param.AHZFYInfoObject = this.AHZFYInfoObject
      param.chinaUnionPayInfoObject = this.chinaUnionPayInfoObject
      param.PYunPayInfoObject = this.PYunPayInfoObject
      param.CSRCBPayInfoObject = this.CSRCBPayInfoObject
      param.BSTInfoObject = this.BSTInfoObject
      param.BSTTwoInfoObject = this.BSTTwoInfoObject
      param.PYUNInfoObject = this.PYUNInfoObject
      param.mobobInfoObject = this.mobobInfoObject
      param.HXInvoiceObject = this.HXInvoiceObject
      param.HTInvoiceObject = this.HTInvoiceObject
      param.TJHTInvObject = this.TJHTInvObject
      param.BJHTInvObject = this.BJHTInvObject
      param.BSTADReg = this.BSTADReg
      if (param.BSTADReg.fStartDate instanceof Date) {
        param.BSTADReg.fStartDate = this.$dateFormat(param.BSTADReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.BSTADReg.fEndDate instanceof Date) {
        param.BSTADReg.fEndDate = this.$dateFormat(param.BSTADReg.fEndDate, 'yyyy-MM-dd')
      }
      param.unionPayReg = this.unionPayReg
      if (param.unionPayReg.fStartDate instanceof Date) {
        param.unionPayReg.fStartDate = this.$dateFormat(param.unionPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.unionPayReg.fEndDate instanceof Date) {
        param.unionPayReg.fEndDate = this.$dateFormat(param.unionPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.aliPayReg = this.aliPayReg
      if (param.aliPayReg.fStartDate instanceof Date) {
        param.aliPayReg.fStartDate = this.$dateFormat(param.aliPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.aliPayReg.fEndDate instanceof Date) {
        param.aliPayReg.fEndDate = this.$dateFormat(param.aliPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.weChatComPayReg = this.weChatComPayReg
      if (param.weChatComPayReg.fStartDate instanceof Date) {
        param.weChatComPayReg.fStartDate = this.$dateFormat(param.weChatComPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.weChatComPayReg.fEndDate instanceof Date) {
        param.weChatComPayReg.fEndDate = this.$dateFormat(param.weChatComPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.weChatSvrPayReg = this.weChatSvrPayReg
      if (param.weChatSvrPayReg.fStartDate instanceof Date) {
        param.weChatSvrPayReg.fStartDate = this.$dateFormat(param.weChatSvrPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.weChatSvrPayReg.fEndDate instanceof Date) {
        param.weChatSvrPayReg.fEndDate = this.$dateFormat(param.weChatSvrPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.BOCMWxPayReg = this.BOCMWxPayReg
      if (param.BOCMWxPayReg.fStartDate instanceof Date) {
        param.BOCMWxPayReg.fStartDate = this.$dateFormat(param.BOCMWxPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.BOCMWxPayReg.fEndDate instanceof Date) {
        param.BOCMWxPayReg.fEndDate = this.$dateFormat(param.BOCMWxPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.ICBCPayReg = this.ICBCPayReg
      if (param.ICBCPayReg.fStartDate instanceof Date) {
        param.ICBCPayReg.fStartDate = this.$dateFormat(param.ICBCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.ICBCPayReg.fEndDate instanceof Date) {
        param.ICBCPayReg.fEndDate = this.$dateFormat(param.ICBCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CGBPayReg = this.CGBPayReg
      if (param.CGBPayReg.fStartDate instanceof Date) {
        param.CGBPayReg.fStartDate = this.$dateFormat(param.CGBPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CGBPayReg.fEndDate instanceof Date) {
        param.CGBPayReg.fEndDate = this.$dateFormat(param.CGBPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CGBNewPayReg = this.CGBNewPayReg
      if (param.CGBNewPayReg.fStartDate instanceof Date) {
        param.CGBNewPayReg.fStartDate = this.$dateFormat(param.CGBNewPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CGBNewPayReg.fEndDate instanceof Date) {
        param.CGBNewPayReg.fEndDate = this.$dateFormat(param.CGBNewPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CCBPayReg = this.CCBPayReg
      if (param.CCBPayReg.fStartDate instanceof Date) {
        param.CCBPayReg.fStartDate = this.$dateFormat(param.CCBPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CCBPayReg.fEndDate instanceof Date) {
        param.CCBPayReg.fEndDate = this.$dateFormat(param.CCBPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.SPDPayReg = this.SPDPayReg
      if (param.SPDPayReg.fStartDate instanceof Date) {
        param.SPDPayReg.fStartDate = this.$dateFormat(param.SPDPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.SPDPayReg.fEndDate instanceof Date) {
        param.SPDPayReg.fEndDate = this.$dateFormat(param.SPDPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.ABCPayReg = this.ABCPayReg
      if (param.ABCPayReg.fStartDate instanceof Date) {
        param.ABCPayReg.fStartDate = this.$dateFormat(param.ABCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.ABCPayReg.fEndDate instanceof Date) {
        param.ABCPayReg.fEndDate = this.$dateFormat(param.ABCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CQETCPayReg = this.CQETCPayReg
      if (param.CQETCPayReg.fStartDate instanceof Date) {
        param.CQETCPayReg.fStartDate = this.$dateFormat(param.CQETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CQETCPayReg.fEndDate instanceof Date) {
        param.CQETCPayReg.fEndDate = this.$dateFormat(param.CQETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.QTETCPayReg = this.QTETCPayReg
      if (param.QTETCPayReg.fStartDate instanceof Date) {
        param.QTETCPayReg.fStartDate = this.$dateFormat(param.QTETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.QTETCPayReg.fEndDate instanceof Date) {
        param.QTETCPayReg.fEndDate = this.$dateFormat(param.QTETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.SZSFETCPayReg = this.SZSFETCPayReg
      if (param.SZSFETCPayReg.fStartDate instanceof Date) {
        param.SZSFETCPayReg.fStartDate = this.$dateFormat(param.SZSFETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.SZSFETCPayReg.fEndDate instanceof Date) {
        param.SZSFETCPayReg.fEndDate = this.$dateFormat(param.SZSFETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.SHETCPayReg = this.SHETCPayReg
      if (param.SHETCPayReg.fStartDate instanceof Date) {
        param.SHETCPayReg.fStartDate = this.$dateFormat(param.SHETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.SHETCPayReg.fEndDate instanceof Date) {
        param.SHETCPayReg.fEndDate = this.$dateFormat(param.SHETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.MYZXETCPayReg = this.MYZXETCPayReg
      if (param.MYZXETCPayReg.fStartDate instanceof Date) {
        param.MYZXETCPayReg.fStartDate = this.$dateFormat(param.MYZXETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.MYZXETCPayReg.fEndDate instanceof Date) {
        param.MYZXETCPayReg.fEndDate = this.$dateFormat(param.MYZXETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.HTETCPayReg = this.HTETCPayReg
      if (param.HTETCPayReg.fStartDate instanceof Date) {
        param.HTETCPayReg.fStartDate = this.$dateFormat(param.HTETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.HTETCPayReg.fEndDate instanceof Date) {
        param.HTETCPayReg.fEndDate = this.$dateFormat(param.HTETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.YunZongPayReg = this.YunZongPayReg
      if (param.YunZongPayReg.fStartDate instanceof Date) {
        param.YunZongPayReg.fStartDate = this.$dateFormat(param.YunZongPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.YunZongPayReg.fEndDate instanceof Date) {
        param.YunZongPayReg.fEndDate = this.$dateFormat(param.YunZongPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.YunZongADPayReg = this.YunZongADPayReg
      if (param.YunZongADPayReg.fStartDate instanceof Date) {
        param.YunZongADPayReg.fStartDate = this.$dateFormat(param.YunZongADPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.YunZongADPayReg.fEndDate instanceof Date) {
        param.YunZongADPayReg.fEndDate = this.$dateFormat(param.YunZongADPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.AppletPayReg = this.AppletPayReg
      if (param.AppletPayReg.fStartDate instanceof Date) {
        param.AppletPayReg.fStartDate = this.$dateFormat(param.AppletPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.AppletPayReg.fEndDate instanceof Date) {
        param.AppletPayReg.fEndDate = this.$dateFormat(param.AppletPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.saobeiPayReg = this.saobeiPayReg
      if (param.saobeiPayReg.fStartDate instanceof Date) {
        param.saobeiPayReg.fStartDate = this.$dateFormat(param.saobeiPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.saobeiPayReg.fEndDate instanceof Date) {
        param.saobeiPayReg.fEndDate = this.$dateFormat(param.saobeiPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.GRGPayReg = this.GRGPayReg
      if (param.GRGPayReg.fStartDate instanceof Date) {
        param.GRGPayReg.fStartDate = this.$dateFormat(param.GRGPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.GRGPayReg.fEndDate instanceof Date) {
        param.GRGPayReg.fEndDate = this.$dateFormat(param.GRGPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.AHSRCBPayReg = this.AHSRCBPayReg
      if (param.AHSRCBPayReg.fStartDate instanceof Date) {
        param.AHSRCBPayReg.fStartDate = this.$dateFormat(param.AHSRCBPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.AHSRCBPayReg.fEndDate instanceof Date) {
        param.AHSRCBPayReg.fEndDate = this.$dateFormat(param.AHSRCBPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.mobobPayReg = this.mobobPayReg
      if (param.mobobPayReg.fStartDate instanceof Date) {
        param.mobobPayReg.fStartDate = this.$dateFormat(param.mobobPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.mobobPayReg.fEndDate instanceof Date) {
        param.mobobPayReg.fEndDate = this.$dateFormat(param.mobobPayReg.fEndDate, 'yyyy-MM-dd')
      }
      this.save_loading = true
      this.save_msg = '保存中…'
      this.saveParkPay(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.initData()
              this.parkEditOrDetailVisible = false
              this.$message({
                type: 'success',
                message: data.Msg
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    setDefault () {
      for (let key in this.alipayInfoObject) {
        this.alipayInfoObject[key] = ''
      }
      for (let key in this.wechatComInfoObject) {
        this.wechatComInfoObject[key] = ''
      }
      for (let key in this.wechatSerInfoObject) {
        this.wechatSerInfoObject[key] = ''
      }
      for (let key in this.unionPayInfoObject) {
        this.unionPayInfoObject[key] = ''
      }
      for (let key in this.BOCMWxInfoObject) {
        this.BOCMWxInfoObject[key] = ''
      }
      for (let key in this.RJInvoiceObject) {
        this.RJInvoiceObject[key] = ''
      }
      for (let key in this.EInvoiceObject) {
        this.EInvoiceObject[key] = ''
      }
      for (let key in this.ICBCInfoObject) {
        this.ICBCInfoObject[key] = ''
      }
      for (let key in this.CGBInfoObject) {
        this.CGBInfoObject[key] = ''
      }
      for (let key in this.CGBNewInfoObject) {
        this.CGBNewInfoObject[key] = ''
      }
      for (let key in this.CCBInfoObject) {
        this.CCBInfoObject[key] = ''
      }
      for (let key in this.SPDInfoObject) {
        this.SPDInfoObject[key] = ''
      }
      for (let key in this.ABCInfoObject) {
        this.ABCInfoObject[key] = ''
      }
      for (let key in this.CQETCInfoObject) {
        this.CQETCInfoObject[key] = ''
      }
      for (let key in this.QTETCInfoObject) {
        this.QTETCInfoObject[key] = ''
      }
      for (let key in this.SHETCInfoObject) {
        this.SHETCInfoObject[key] = ''
      }
      for (let key in this.MYZXETCInfoObject) {
        this.MYZXETCInfoObject[key] = ''
      }
      for (let key in this.HTETCInfoObject) {
        this.HTETCInfoObject[key] = ''
      }
      for (let key in this.YunZongInfoObject) {
        this.YunZongInfoObject[key] = ''
      }
      for (let key in this.YunZongADInfoObject) {
        this.YunZongADInfoObject[key] = ''
      }
      for (let key in this.AppletInfoObject) {
        this.AppletInfoObject[key] = ''
      }
      for (let key in this.unionEInvoiceObject) {
        this.unionEInvoiceObject[key] = ''
      }
      this.unionEInvoiceObject.p99509 = '5'
      this.unionEInvoiceObject.p99518 = '车辆停放服务'
      this.unionEInvoiceObject.p99519 = '3040502020200000000'
      for (let key in this.gdEInvoiceObject) {
        this.gdEInvoiceObject[key] = ''
      }
      for (let key in this.saobeiInfoObject) {
        this.saobeiInfoObject[key] = ''
      }
      for (let key in this.GRGInfoObject) {
        this.GRGInfoObject[key] = ''
      }
      for (let key in this.AHZFYInfoObject) {
        this.AHZFYInfoObject[key] = ''
      }
      for (let key in this.chinaUnionPayInfoObject) {
        this.chinaUnionPayInfoObject[key] = ''
      }
      for (let key in this.PYunPayInfoObject) {
        this.PYunPayInfoObject[key] = ''
      }
      for (let key in this.CSRCBPayInfoObject) {
        this.CSRCBPayInfoObject[key] = ''
      }
      for (let key in this.BSTInfoObject) {
        this.BSTInfoObject[key] = ''
      }
      for (let key in this.BSTTwoInfoObject) {
        this.BSTTwoInfoObject[key] = ''
      }
      for (let key in this.PYUNInfoObject) {
        this.PYUNInfoObject[key] = ''
      }
      this.NYCRMInfo = {
        p93310: '',
        p93320: '',
        p93330: '0'
      }
      this.JGDTInfo = {
        p93351: '',
        p93352: '',
        p93353: '0',
        p93354: '',
        p93355: ''
      }
      this.FMInfo = {
        p94131: '',
        p94132: '0'
      }
      this.NBYSInfo = {
        p93610: '',
        p93620: '',
        p93630: '',
        p93640: '0'
      }
      this.SHJBHPayInfo = {
        p94141: '',
        p94142: '',
        p94143: '',
        p94144: 'http://parkzhtc.jtcx.sh.cn',
        p94145: '80',
        p94147: '0',
        p94148: '0',
        p94139: '0'
      }
      this.SHJBHPayInfo1 = {
        p941401: '',
        p941402: '',
        p941403: '',
        p941404: 'http://parkzhtc.jtcx.sh.cn',
        p941405: '80',
        p941406: '0'
      }
      this.SHCardPayInfo = {
        p94151: '',
        p94152: '',
        p94153: '',
        p94154: '',
        p94155: '',
        p94156: '0'
      }
      this.mobobInfoObject = {
        p79501: 'https://tapi.teemall.com.cn/api/v3',
        p79502: '',
        p78503: '',
        p79504: '0'
      }
      this.CQETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.QTETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.SHETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.MYZXETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.HTETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.YunZongPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.YunZongADPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.CGBPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.CGBNewPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.CCBPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.SPDPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.ABCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.unionPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.aliPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.weChatComPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.weChatSvrPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.BOCMWxPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.ICBCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.AppletPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.saobeiPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.GRGPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.BSTADReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.AHSRCBPayInfoObject = {
        p79401: '',
        p79402: '',
        p79403: 'https://epos.ahrcu.com:3443',
        p79404: '',
        p79405: '0',
        p79406: 'http://ansrcbpay.shangjieiot.com:19080'
      }
      this.AHSRCBPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.mobobPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.HXInvoiceObject = {
        p99701: '0',
        p99702: '',
        p99703: '',
        p99704: '',
        p99705: '',
        p99706: '',
        p99707: '',
        p99708: '',
        p99709: '',
        p99710: '',
        p99711: '',
        p99712: '0',
        p99713: '30',
        p99714: ''
      }
      this.TeslaInfoObject = this.$options.data().TeslaInfoObject
      this.CubeInfoObject = this.$options.data().CubeInfoObject
      this.SamsClubInfoObject = this.$options.data().SamsClubInfoObject
      this.HTInvoiceObject = this.$options.data().HTInvoiceObject
      this.TJHTInvObject = this.$options.data().TJHTInvObject
      this.BJHTInvObject = this.$options.data().BJHTInvObject
      this.SZSFETCPayReg = this.$options.data().SZSFETCPayReg
      this.SZSFETCInfoObject = this.$options.data().SZSFETCInfoObject
      this.aliSRObject = this.$options.data().aliSRObject
      this.TeslaInfoObject.p79603 = '0'
      this.CubeInfoObject.p79652 = '0'
      this.SamsClubInfoObject.p94301 = '50'
      this.SamsClubInfoObject.p94302 = '120'
      this.SamsClubInfoObject.p94303 = '0'
      this.BSTInfoObject.p78558 = '0'
      this.BSTTwoInfoObject.p78578 = '0'
      this.BSTTwoInfoObject.p78575 = '310000'
      this.BSTTwoInfoObject.p78577 = 'https://api.zysdsk.cn/api/ad/bid'
      this.BSTTwoInfoObject.p78579 = '6602112'
      this.BSTTwoInfoObject.p78572 = 'c2q79ts3n3sxxdyt'
      this.BSTTwoInfoObject.p78571 = '0lyee14nf1oi0x0dusnrprxxxgbtioko'
      this.BSTTwoInfoObject.p78574 = '1'
      this.PYUNInfoObject.p99952 = '0'
      this.AHZFYInfoObject.p79709 = '0'
      this.chinaUnionPayInfoObject.p79809 = '0'
      this.chinaUnionPayInfoObject.p79810 = '0'
      this.PYunPayInfoObject.p94174 = '0'
      this.PYunPayInfoObject.p94175 = '0'
      this.PYunPayInfoObject.p94176 = 'https://api.4pyun.com/gate/1.0/payment/trade'
      this.CSRCBPayInfoObject.p79911 = '0'
      // this.isEdit = false
      this.unionPayInfoObject.p71060 = '0'
      this.unionPayInfoObject.p71190 = '0'
      this.unionPayInfoObject.p71350 = '0'
      this.unionPayInfoObject.p71221 = '0'
      this.unionPayInfoObject.p71409 = '0'
      this.unionPayInfoObject.p71426 = '0'
      this.wechatSerInfoObject.p72070 = '0'
      this.wechatSerInfoObject.p72120 = '0'
      this.wechatSerInfoObject.p72182 = '0'
      this.wechatSerInfoObject.p72183 = '0'
      this.wechatSerInfoObject.p72190 = '0'
      this.wechatSerInfoObject.p72121 = '0'
      this.wechatSerInfoObject.p72170 = '0'
      this.wechatComInfoObject.p73050 = '0'
      this.wechatComInfoObject.p73091 = '0'
      this.alipayInfoObject.p74060 = '0'
      this.alipayInfoObject.p74004 = '0'
      this.aliSRObject.p74108 = '0'
      this.BOCMWxInfoObject.p75080 = '0'
      this.RJInvoiceObject.p99160 = '0'
      this.RJInvoiceObject.p99151 = '30'
      this.EInvoiceObject.p99299 = '0'
      this.EInvoiceObject.p99291 = '30'
      this.ICBCInfoObject.p76090 = '0'
      this.ICBCInfoObject.p76091 = '0'
      this.CGBInfoObject.p77050 = '0'
      this.CGBNewInfoObject.p77509 = '0'
      this.CQETCInfoObject.p78150 = '0'
      this.QTETCInfoObject.p78240 = '0'
      this.SZSFETCInfoObject.p78904 = '0'
      this.SHETCInfoObject.p78640 = '0'
      this.MYZXETCInfoObject.p78730 = '0'
      this.HTETCInfoObject.p78804 = '0'
      this.YunZongInfoObject.p78490 = '0'
      this.YunZongADInfoObject.p78590 = '0'
      this.AppletInfoObject.p73152 = '0'
      this.AppletInfoObject.p73165 = '0'
      this.CCBInfoObject.p79070 = '0'
      this.CCBInfoObject.p79080 = '0'
      this.SPDInfoObject.p79100 = '0'
      this.SPDInfoObject.p79109 = '0'
      this.ABCInfoObject.p79150 = '0'
      this.ABCInfoObject.p79158 = '0'
      this.unionEInvoiceObject.p99507 = '0'
      this.unionEInvoiceObject.p99508 = '30'
      this.gdEInvoiceObject.p99607 = '0'
      this.gdEInvoiceObject.p99611 = '30'
      this.gdEInvoiceObject.p99610 = 'http://einvapi.shangjieiot.com:8081/EInv/Invoice/QueryByCode'
      this.saobeiInfoObject.p79185 = '0'
      this.GRGInfoObject.p79205 = '0'
      this.mobobInfoObject.p79504 = '0'
      this.mobobInfoObject.p79501 = 'https://tapi.teemall.com.cn/api/v3'
      this.PYUNInfoObject.p99951 = 'op0889976cd7925c7'
      this.aliSRObject.p74104 = '2088531665011033'
      this.aliSRObject.p74106 = 'https://openapi.alipay.com/gateway.do'
      this.aliSRObject.p74101 = '2021003162606318'
      this.aliSRObject.p74102 = 'MIIEpAIBAAKCAQEAo8JdEhdIeJpmqKxhT8FXCUrUh00lvETbzRwZVFxHy0cG3g741mg4v3sbkllS6nFrJadTXbRKT/hYm7tge+SdNib9ANatdaFxLSnqwfqk4Uv+0ekv0llvoTxjaV9h1S4DoNRVVgPCG52C+jZ1Bvm7hbA0aI6Dk7OAy/zOeuDWkHR/XwegjIJpTvyviqgAQoFJt9k03SfRrQG2x2sl45wc1XKW46TQloXdQZLt5kMKVclTFwn2+62dsFaG46WRzmsnaXINcRh+4ROyyp6NSOMBDTjkhaPcZwyZmxTuNPHJTUL5+48A8e2+3hb6bHDWYfCTeMOYf+tffNljsM8UhkybhwIDAQABAoIBAGeHAP/m6FIWisAn+n1JZZTiUeoXw7t6bNsG4JyMmnbQuG66WGZ0DSxAz/V9swW0HmD3n6SlzjUwdBRAKYcpyJnrnBdjoNW08q/yyA9KPeKRANAD88+v6vqsCs0bF+aF6JVMp4Zxac27jopQ0ztNtleWRguzzUsbOFm9wWu9qOg5OwIJ8uDvvZaj2La6ekXbEO0l/wMyJ1gF7al5hMYWLq/6PFbQfyh6znNNw4D0fSm5BseXw8/sSlTR3WGPFVp7qdUadchCYHlYfpXhSm5qRUC9CMKI8Fn/v2OSRyNz10N5Tv+gupKN6QuOxDNbiz3lFDoHfMw8w6IP5LZrRTdGUgECgYEA1oaiztgXhGfKmQ528sMw5Ii2AgbdSOneVmpDcZRtswCg0usjl7t/5Onfp/PmTs1Go4qeHYZma8bkez2S3JVcT1eFg3WlYWT40ewdi2WEYJaq83hx3TAsOuj810PGbUk6eiI5GD6XiM2eGdCD35c9ykv5FwpvtnkrTriXy4IyoSECgYEAw2sr5Pb77pn5/QM3Oa+fvRHuSEhR4jfC5xC9ozV1kEyusVQ3u0vcWzcM2TUxMi1fPbTdRWqAa+MLBNsI7WpiG4mq1AMcQu4V4uflf1glBIqCnN/OxbVq6irw7It4/2/WXJlsfC43vWVLv7mJON8PzPySzg2SGjecDCHJelTyn6cCgYEAknJYxEGqVD4ShUfllbYAM5LMRTfwai0VFgL2xZuhA5jDMRlKM/PQzDGH9/y9VUA3H7+qTteIJb0iDqurDSB9YsCJqYNvgbxPS+cXCCkmJFXWn9yyRl/zYcfZiw5+b+6Ul/my5kUcZ0yOyGqbC9EQYoBYrAz41CWFlfjXzxqze2ECgYB5rz2I+MbNv7Gr/BmiYRrd19GBzw62B7Tkv0bm3z4Smb1aDLAbf9R6NCBbDMVSknAw83OpavUGuT0+S8oWVF08+o+WL02k265jObVtg4yhdEJ6vt55vEsT/6NAGGVC4fggdyTXeswYsn/lpfmtoTCsm0Yq6sZkbuZLo6pa85SVFwKBgQC/veJSxIYflNiZ4wU4bbxHhwiLShg6OxjjaACB0h+C+P4GlUheNtat2HGRkFT5Odl/6BYtP65abt4ZXejZ01ZlWT7yAam/gEypBXj4SQaSVn/EpK0BGQ0GomJ20gXoI0MKZnLc5cw7fafONzgt7TqAqI8KETubXUL8QbvDL0jHIA=='
      this.aliSRObject.p74103 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiBoXDptcd7R9oZ6OLJv89+gVPCRrnTJ5ImihRh0AxVgROmgCkV2obN2kvnr8DYQJcUApm9IIBqCfkWMjiTf0vPkOJ8qYLF9B+iaAnwUeIGdpsZBJS7TgfW+U0era0K3dLlLhorjBhu9SonmIoYXQ2l4IF+sXHduzUkgI572dNL/D5/CENZeFLfJ1EkpEBuFjj7XX2Wa7K3UNfdTKynO+ELfdwqw7stUTSmHScWtGbGT0tvIvL1G5XZtO4DFsBPHG+p+s/ytfDt2aDvF9qaC0+/rmF13AYJdzAGkcIfVHqYOktnUATJp/6KSSRknRbUxovXil14aAcnuxHdWkcILHpQIDAQAB'
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      let param = {}
      param['fParkName'] = this.bindQueryInput.trim()
      param['fParkNo'] = this.bindQueryfParkNo.trim()
      param['fCustID'] = this.selCustID
      param.parkActiveName = this.parkActiveName
      this.getParkPayParams(param).then(res => {
        this.export_loading = false
        this.export_msg = '导出微信支付宝参数'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_电子支付-微信支付宝参数信息.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    bindQuery () {
      this.initData()
    },
    tab_click (tab) {
      this.setTabHeight($('#' + tab.$el.id).height())
    },
    setTabHeight (contentHeight) {
      var height = $('.parkPayEditOrDetail .el-tabs__content:eq(0)').height()
      if (this.tab_height <= 0) {
        this.tab_height = $('.parkPayEditOrDetail .el-tabs__nav-scroll:eq(0)').height()
      }
      if (contentHeight) {
        $('.parkPayEditOrDetail .el-tabs__nav-scroll:eq(0)').css('height', (this.tab_height > contentHeight ? this.tab_height : contentHeight) + 'px')
      } else {
        $('.parkPayEditOrDetail .el-tabs__nav-scroll:eq(0)').css('height', (height > this.tab_height ? height : this.tab_height) + 'px')
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    updatePark (row, isEdit, op) {
      this.setDefault()
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.isEdit = isEdit
      this.curRowInfo.op = op
      this.detailTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】' + (isEdit ? '编辑场库电子支付/发票' : '查看场库电子支付/发票')
      this.parkEditOrDetailVisible = true

      setTimeout(() => {
        this.setTabHeight()
      }, 100)
      this.getAllParkParamByParkId({ fIsPay: true, fCustID: row.fCustID, fParkID: row.fParkID, fIsSyn: this.parkActiveName === 'synParkList' }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              Object.assign(this.NYCRMInfo, data.Data.NYCRMInfo)
              Object.assign(this.JGDTInfo, data.Data.JGDTInfo)
              Object.assign(this.FMInfo, data.Data.FMInfo)
              Object.assign(this.TeslaInfoObject, data.Data.TeslaInfoObject)
              this.TeslaInfoObject.p79605 = row.fCustNo + '_' + row.fParkNo
              this.TeslaInfoObject.p79606 = row.fParkName
              Object.assign(this.CubeInfoObject, data.Data.CubeInfoObject)
              Object.assign(this.SamsClubInfoObject, data.Data.SamsClubInfoObject)
              Object.assign(this.NBYSInfo, data.Data.NBYSInfo)
              Object.assign(this.unionPayInfoObject, data.Data.unionPayInfoObject)
              // this.unionPay = data.Data.unionPayExist
              if ((this.unionPayInfoObject.p71320 || '').length <= 0) {
                this.unionPayInfoObject.p71320 = 'RJ'
              }
              if ((this.unionPayInfoObject.p71340 || '').length <= 0) {
                this.unionPayInfoObject.p71340 = '2vWgS9BxIpmPfy0CNpS4n04TfqER1daLXgTkbJZvZSDYOwlR'
              }
              if ((this.unionPayInfoObject.p71341 || '').length <= 0) {
                this.unionPayInfoObject.p71341 = 'https://ad.chinaums.com/ecology/web-api/unionPayPark/exportApi'
              }
              Object.assign(this.wechatSerInfoObject, data.Data.wechatSerInfoObject)
              // this.wechatSer = data.Data.wechatSerExist // this.wechatSerInfoObject && this.wechatSerInfoObject.length > 0

              Object.assign(this.wechatComInfoObject, data.Data.wechatComInfoObject)
              // this.wechatCom = data.Data.wechatComExist // this.wechatComInfoObject && this.wechatComInfoObject.length > 0

              Object.assign(this.alipayInfoObject, data.Data.alipayInfoObject)
              // this.alipay = data.Data.alipayExist// this.alipayInfoObject && this.alipayInfoObject.length > 0

              Object.assign(this.aliSRObject, data.Data.aliSRObject)

              Object.assign(this.ICBCInfoObject, data.Data.ICBCInfoObject)

              Object.assign(this.CGBInfoObject, data.Data.CGBInfoObject)
              if ((this.CGBInfoObject.p77040 || '').length <= 0) {
                this.CGBInfoObject.p77040 = 'https://pay.swiftpass.cn/pay/gateway'
              }
              Object.assign(this.CGBNewInfoObject, data.Data.CGBNewInfoObject)
              if ((this.CGBNewInfoObject.p77510 || '').length <= 0) {
                this.CGBNewInfoObject.p77510 = 'https://open.cgbchina.com.cn/gateway/API'
              }
              if ((this.CGBNewInfoObject.p77504 || '').length <= 0) {
                this.CGBNewInfoObject.p77504 = '1.0.0'
              }
              if ((this.CGBNewInfoObject.p77505 || '').length <= 0) {
                this.CGBNewInfoObject.p77505 = 'payService'
              }
              if ((this.CGBNewInfoObject.p77508 || '').length <= 0) {
                this.CGBNewInfoObject.p77508 = '3059301306072a8648ce3d020106082a811ccf5501822d03420004b137a3b989baddeb39c5ea8db90a58c61a6b1932ad5a45b789ac2fc2cfa45c391fb2f577a46f52751d9e43f7a1c90f4914cb183fe0a8e2fe46e93014550dc41e'
              }
              Object.assign(this.BSTInfoObject, data.Data.BSTInfoObject)
              if ((this.BSTInfoObject.p78553 || '').length <= 0) {
                this.BSTInfoObject.p78553 = row.fCustNo + '-' + row.fParkNo
              }
              if ((this.BSTInfoObject.p78557 || '').length <= 0) {
                this.BSTInfoObject.p78557 = 'http://api.ad.parking520.com'
              }
              if ((this.BSTInfoObject.p78551 || '').length <= 0) {
                this.BSTInfoObject.p78551 = 'e5cfd644158047039404d3dce5a26c20'
              }
              if ((this.BSTInfoObject.p78552 || '').length <= 0) {
                this.BSTInfoObject.p78552 = 'b20666df692d43da'
              }
              if ((this.BSTInfoObject.p78554 || '').length <= 0) {
                switch (row.fParkTypeID) {
                  case '100':
                    this.BSTInfoObject.p78554 = '2'
                    break
                  case '101':
                    this.BSTInfoObject.p78554 = '4'
                    break
                  case '102':
                    this.BSTInfoObject.p78554 = '0'
                    break
                  case '103':
                    this.BSTInfoObject.p78554 = '12'
                    break
                  case '104':
                    this.BSTInfoObject.p78554 = '7'
                    break
                }
              }
              if ((this.BSTInfoObject.p78555 || '').length <= 0) {
                this.BSTInfoObject.p78555 = row.fAddress
              }
              Object.assign(this.BSTTwoInfoObject, data.Data.BSTTwoInfoObject)
              if ((this.BSTTwoInfoObject.p78573 || '').length <= 0) {
                this.BSTTwoInfoObject.p78573 = row.fCustNo + '-' + row.fParkNo
              }
              if ((this.BSTTwoInfoObject.p78577 || '').length <= 0) {
                this.BSTTwoInfoObject.p78577 = 'https://api.zysdsk.cn'
              }
              if ((this.BSTTwoInfoObject.p78577 || '').length <= 0) {
                this.BSTTwoInfoObject.p78577 = '310000'
              }
              if ((this.BSTTwoInfoObject.p78571 || '').length <= 0) {
                this.BSTTwoInfoObject.p78571 = 'e5cfd644158047039404d3dce5a26c20'
              }
              if ((this.BSTTwoInfoObject.p78572 || '').length <= 0) {
                this.BSTTwoInfoObject.p78572 = 'b20666df692d43da'
              }
              if ((this.BSTTwoInfoObject.p78574 || '').length <= 0) {
                switch (row.fParkTypeID) {
                  case '100':
                    this.BSTTwoInfoObject.p78574 = '2'
                    break
                  case '101':
                    this.BSTTwoInfoObject.p78574 = '4'
                    break
                  case '102':
                    this.BSTTwoInfoObject.p78574 = '0'
                    break
                  case '103':
                    this.BSTTwoInfoObject.p78574 = '12'
                    break
                  case '104':
                    this.BSTTwoInfoObject.p78574 = '7'
                    break
                }
              }
              if ((this.BSTTwoInfoObject.p78575 || '').length <= 0) {
                this.BSTTwoInfoObject.p78575 = row.fAddress
              }
              Object.assign(this.PYUNInfoObject, data.Data.PYUNInfoObject)
              Object.assign(this.CQETCInfoObject, data.Data.CQETCInfoObject)
              Object.assign(this.QTETCInfoObject, data.Data.QTETCInfoObject)
              Object.assign(this.SZSFETCInfoObject, data.Data.SZSFETCInfoObject)
              Object.assign(this.SHETCInfoObject, data.Data.SHETCInfoObject)
              if ((this.SHETCInfoObject.p78650 || '').length <= 0) {
                this.SHETCInfoObject.p78650 = 'https://parking.sptcc.com:8443/etc/etcparking'
              }
              if ((this.SHETCInfoObject.p78660 || '').length <= 0) {
                this.SHETCInfoObject.p78660 = 'ETC_PARK_DIRECT'
              }
              if ((this.SHETCInfoObject.p78670 || '').length <= 0) {
                this.SHETCInfoObject.p78670 = 'GNDUFjWGE5hUF04j9Dw'
              }
              if (data.Data.HTInvoiceObject.p99808 === '1') {
                this.flagTemp = true
              } else {
                this.flagTemp = false
              }
              Object.assign(this.MYZXETCInfoObject, data.Data.MYZXETCInfoObject)
              Object.assign(this.HTETCInfoObject, data.Data.HTETCInfoObject)
              Object.assign(this.YunZongInfoObject, data.Data.YunZongInfoObject)
              Object.assign(this.YunZongADInfoObject, data.Data.YunZongADInfoObject)
              Object.assign(this.AppletInfoObject, data.Data.AppletInfoObject)
              Object.assign(this.BOCMWxInfoObject, data.Data.BOCMWxInfoObject)
              Object.assign(this.RJInvoiceObject, data.Data.RJInvoiceObject)
              Object.assign(this.EInvoiceObject, data.Data.EInvoiceObject)
              Object.assign(this.unionEInvoiceObject, data.Data.unionEInvoiceObject)
              Object.assign(this.gdEInvoiceObject, data.Data.gdEInvoiceObject)
              Object.assign(this.unionPayReg, data.Data.unionPayReg)
              Object.assign(this.aliPayReg, data.Data.aliPayReg)
              Object.assign(this.weChatComPayReg, data.Data.weChatComPayReg)
              Object.assign(this.weChatSvrPayReg, data.Data.weChatSvrPayReg)
              Object.assign(this.BOCMWxPayReg, data.Data.BOCMWxPayReg)
              Object.assign(this.ICBCPayReg, data.Data.ICBCPayReg)
              Object.assign(this.CGBPayReg, data.Data.CGBPayReg)
              Object.assign(this.CGBNewPayReg, data.Data.CGBNewPayReg)
              Object.assign(this.CQETCPayReg, data.Data.CQETCPayReg)
              Object.assign(this.QTETCPayReg, data.Data.QTETCPayReg)
              Object.assign(this.SZSFETCPayReg, data.Data.SZSFETCPayReg)
              Object.assign(this.SHETCPayReg, data.Data.SHETCPayReg)
              Object.assign(this.MYZXETCPayReg, data.Data.MYZXETCPayReg)
              Object.assign(this.HTETCPayReg, data.Data.HTETCPayReg)
              Object.assign(this.YunZongPayReg, data.Data.YunZongPayReg)
              Object.assign(this.YunZongADPayReg, data.Data.YunZongADPayReg)
              Object.assign(this.CCBPayReg, data.Data.CCBPayReg)
              Object.assign(this.SPDInfoObject, data.Data.SPDInfoObject)
              if ((this.SPDInfoObject.p79105 || '').length <= 0) {
                this.SPDInfoObject.p79105 = 'https://cloud-tjo2o.spdb.com.cn/prodPmp'
              }
              Object.assign(this.SPDPayReg, data.Data.SPDPayReg)
              Object.assign(this.ABCInfoObject, data.Data.ABCInfoObject)
              if ((this.ABCInfoObject.p79151 || '').length <= 0) {
                this.ABCInfoObject.p79151 = 'https://e.abchina.com/js/sz/WcfServiceAccess/service1.svc/Access'
              }
              Object.assign(this.ABCPayReg, data.Data.ABCPayReg)
              Object.assign(this.AppletPayReg, data.Data.AppletPayReg)
              Object.assign(this.CCBInfoObject, data.Data.CCBInfoObject)
              Object.assign(this.SHJBHPayInfo, data.Data.SHJBHPayInfo)
              Object.assign(this.SHJBHPayInfo1, data.Data.SHJBHPayInfo1)
              Object.assign(this.SHCardPayInfo, data.Data.SHCardPayInfo)
              Object.assign(this.saobeiPayReg, data.Data.saobeiPayReg)
              Object.assign(this.saobeiInfoObject, data.Data.saobeiInfoObject)
              Object.assign(this.GRGPayReg, data.Data.GRGPayReg)
              Object.assign(this.GRGInfoObject, data.Data.GRGInfoObject)
              Object.assign(this.AHSRCBPayReg, data.Data.AHSRCBPayReg)
              Object.assign(this.AHSRCBPayInfoObject, data.Data.AHSRCBPayInfoObject)
              Object.assign(this.mobobPayReg, data.Data.mobobPayReg)
              Object.assign(this.mobobInfoObject, data.Data.mobobInfoObject)
              Object.assign(this.HXInvoiceObject, data.Data.HXInvoiceObject)
              Object.assign(this.HTInvoiceObject, data.Data.HTInvoiceObject)
              Object.assign(this.TJHTInvObject, data.Data.TJHTInvObject)
              Object.assign(this.BJHTInvObject, data.Data.BJHTInvObject)
              Object.assign(this.AHZFYInfoObject, data.Data.AHZFYInfoObject)
              Object.assign(this.chinaUnionPayInfoObject, data.Data.chinaUnionPayInfoObject)
              Object.assign(this.PYunPayInfoObject, data.Data.PYunPayInfoObject)
              Object.assign(this.CSRCBPayInfoObject, data.Data.CSRCBPayInfoObject)
              // this.unionPayStatus = data.Data.unionPayStatus
              // this.wechatSerStatus = data.Data.wechatSerStatus
              // this.wechatComStatus = data.Data.wechatComStatus
              // this.alipayStatus = data.Data.alipayStatus
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    viewPark (row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, false, 'view')
      }
    },
    synPark (index, row, isSyn) {
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将客户[' + row.fCustName + ']的场库[' + row.fParkName + ']电子支付/发票参数' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.synParkById({
            fBigRowID: row.fBigRowID,
            fIsSyn: isSyn,
            fIsPay: true
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.initData()
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }).catch(() => { })
      }
    },
    editParkClient (index, row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, true, 'edit')
      }
    },
    deleteParkClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletePark({ fBigRowID: row.fBigRowID, fIsSyn: this.parkActiveName === 'synParkList', fIsPay: true }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    initData () {
      let param = {}
      param['fCustID'] = this.selCustID
      param['fParkName'] = this.bindQueryInput.trim()
      param['fParkNo'] = this.bindQueryfParkNo.trim()
      param['fPayTypeList'] = this.selPayType
      param.pageSize = this.pageSize
      param.pageIndex = this.pageIndex
      param.parkActiveName = this.parkActiveName
      param.isPay = true
      var isSyn = this.parkActiveName === 'synParkList'
      if (isSyn) {
        this.synParkList = []
      } else {
        this.parkList = []
      }
      this.loading = true
      this.getParkByCurrUser(param).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (isSyn) {
                this.synParkList = data.Data.data || []
              } else {
                this.parkList = data.Data.data || []
              }
              this.total = data.Data.count
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 23000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
            this.is_admin = data.Data.is_admin
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
    user.initConfig().then((res) => {
      let { data } = res
      if (data.IsOk) {
        this.pay_url = data.Data.payUrl
      }
    })
    this.getPayUrl().then(res => {
      let { data } = res
      if (data.IsOk) {
        this.CCBCallbackUrl = data.Data.CCBCallbackUrl
        this.UnionPayCallbackUrl = data.Data.UnionPayCallbackUrl
        this.UnionPayQueryPreAmountUrl = data.Data.UnionPayQueryPreAmountUrl
        this.UnionPayQueryParkInfoUrl = data.Data.UnionPayQueryParkInfoUrl
      }
    })
  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.changeCust(this.selCustID)
            }
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
.parkPayEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}

.parkPayEditOrDetail .el-dialog__title {
  color: white;
}

.parkPayEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}

.parkPayEditOrDetail .el-dialog__body {
  padding: 0px;
}

.parkPayEditOrDetail .myParkInput {
  width: 220px;
}

.parkPayEditOrDetail .el-row {
  margin-top: 5px;
}

.parkPayEditOrDetail .el-radio {
  line-height: 2px;
}

.parkPayEditOrDetail .is-disabled .el-input__inner,
.parkPayEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}

/* tab 样式 */
.parkPayEditOrDetail .el-tabs__item {
  padding: 0px 20px 0px 0px;
}

.parkPayEditOrDetail .el-tabs__nav-scroll {
  background-color: #ccc;
  text-align: center;
  width: 110px;
  overflow: auto;
}

.parkPayEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__nav>.el-tabs__item {
  text-align: right;
}

.parkPayEditOrDetail .el-tabs__nav-next,
.parkPayEditOrDetail .el-tabs__nav-prev {
  display: none;
}

.parkPayEditOrDetail .el-tabs__nav-wrap.is-scrollable {
  padding: 0px !important;
}

.parkPayEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border: none !important;
}

.parkPayEditOrDetail .el-tabs__item:hover {
  color: white;
  background-color: #409eff;
}

.parkPayEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__nav {
  border-bottom: none;
}

.parkPayEditOrDetail .el-tabs__nav {
  margin-top: -1px;
  margin-left: -1px;
}

.parkPayEditOrDetail .el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
}

.parkPayEditOrDetail .fRemark_row .el-form-item__content {
  height: 60px !important;
}

.parkPayEditOrDetail .parkTextArea .el-textarea__inner {
  width: 800px;
  height: 60px !important;
}

.parkPayEditOrDetail .interfaceAPI {
  width: 550px;
}

.parkPayEditOrDetail .fRemark_bigrow .el-form-item__content {
  height: 200px !important;
}

.parkPayEditOrDetail .parkBigTextArea .el-textarea__inner {
  width: 800px;
  height: 200px !important;
}

.parkPayEditOrDetail .child_card .el-tabs__nav-scroll {
  width: 100%;
}

.parkPayEditOrDetail .child_card .el-tabs__item {
  padding: 0px 20px;
  text-align: center !important;
}

#payOnline .warning-row {
  color: chocolate;
}

#payOnline .el-dialog {
  min-width: 1100px;
}
</style>
<style scoped>
fieldset {
  padding-bottom: 0px;
}

.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}

#parkBaiduMap {
  float: left;
}

.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}

.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}

.search_list .el-row {
  margin-top: 0px;
}

.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}

.parkMain_BaseInfo .el-select {
  width: 100%;
}

.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}

.pageSearch .el-form-item {
  margin-bottom: 5px;
}

.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}

.myel-input__inner {
  height: 20px;
  line-height: 20px;
}

legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}

fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}

.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}

.tab_foot {
  float: left;
  width: 110px;
  height: 80px;
  background: #ccc;
}

.btn_foot {
  float: left;
  text-align: right;
  padding: 20px;
}

.dialog-footer {
  text-align: right;
  padding: 20px;
}

.ICBCPay_tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  overflow: hidden;
  margin-top: 15px;
}

.ICBCPay_tip div {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/view/park/payOnline.vue